/* eslint-disable */

// if outdated browser, load polyfills, otherwise skip for modern browsers
var loadPolyfills = function(srcUrl) {
    var js = document.createElement('script');
    if(localStorage.getItem('stlPolyfills') == null || (Date.now() - localStorage.getItem('stlPolyfillsDate') > 8 * 60 * 60 * 1000)) {
        var jsReq;
        jsReq=new XMLHttpRequest();
        jsReq.open('GET',window.location.protocol+"//"+window.location.host+srcUrl, false);
        jsReq.onload = function () {
            if (jsReq.readyState === 4) {
                if (jsReq.status === 200 || jsReq.status === 0) {
                    js.text = jsReq.responseText;
                    localStorage.setItem('stlPolyfills', btoa(js.text));
                    localStorage.setItem('stlPolyfillsDate', Date.now())
                }
            }
        }
        jsReq.send();
    } else {
        js.text = atob(localStorage.getItem('stlPolyfills'));
        localStorage.setItem('stlPolyfillsDate', Date.now())
    }
    document.head.appendChild(js);
}

if(typeof fetch === "undefined") loadPolyfills('/a/97798');

// add both click and keydown event listener
function a11yClick(e){if("click"===e.type)return!0;if("keydown"!==e.type)return!1;var r=e.charCode||e.keyCode;return 32===r||13===r||void 0}

/* eslint-enable */

// form submit - store values in sessionStorage, pass to localStorage temporarily for new tab, pass back to sessionStorage.
// only force user to fill out form once for brochures/guides and pepc
// transfers sessionStorage from one tab to another
var sessionStorage_transfer = function(event) {
    if(!event) { event = window.event; } // ie suq
    if(!event.newValue) return;          // do nothing if no value to work with
    if (event.key == 'getSessionStorage') {
        // another tab asked for the sessionStorage -> send it
        localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
        // the other tab should now have it, so we're done with it.
        localStorage.removeItem('sessionStorage'); // <- could do short timeout as well.
    } else if (event.key == 'sessionStorage' && !sessionStorage.length) {
        // another tab sent data <- get it
        var data = JSON.parse(event.newValue);
        for (var key in data) {
            sessionStorage.setItem(key, data[key]);
        }
    }
};
// listen for changes to localStorage
if(window.addEventListener) {
    window.addEventListener("storage", sessionStorage_transfer, false);
} else {
    window.attachEvent("onstorage", sessionStorage_transfer);
}
// Ask other tabs for session storage (this is ONLY to trigger event)
if (!sessionStorage.length) {
    localStorage.setItem('getSessionStorage', 'stl');
    localStorage.removeItem('getSessionStorage', 'stl');
}

// get previously submitted form values
var sFirst = sessionStorage.getItem('stlFirst');
var sLast = sessionStorage.getItem('stlLast');
var sEmail = sessionStorage.getItem('stlEmail');
var sGuides = sessionStorage.getItem('stlGuides');
var sDiff = sessionStorage.getItem('stlDiff');
var sSubmit = sessionStorage.getItem('stlFormSubmit');

window.loading = windowName => {
    window[windowName] = window.open('about:blank', windowName + Date.now())
    window[windowName].document.write('<!DOCTYPE html><html><head><meta charset="utf-8"><title>Loading</title><meta name="viewport" content="width=device-width,initial-scale=1"></head><body><style>.loaderContainer{position:absolute;top:0;bottom:0;right:0;left:0;background-color:#fff;z-index:10}.loaderContainer .loader{border:16px solid #ddd;border-top:16px solid #3498db;border-radius:50%;width:120px;height:120px;animation:spin 2s linear infinite;position:absolute;left:0;top:0;margin:auto;right:0;bottom:200px;z-index:20}@keyframes spin{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}</style><div class="loaderContainer"><div class="loader"></div></div></body></html>')
}

window.appendFn = (fn, callback) => {
    window[fn] = (function(fn){
        return function() {
            if (typeof fn === 'undefined') {
                console.log('function undefined')
                fn = () => {}
            } else {
                fn()
            }
            callback();
        }
    }(window[fn]));
}

let isZiflow = window.parent !== window && (document.referrer.indexOf('ziflow') > -1 || (typeof window.location.ancestorOrigins !== 'undefined' && typeof window.location.ancestorOrigins[0] !== 'undefined' && window.location.ancestorOrigins[0].indexOf('ziflow') > -1))

const Stelter = {}
Stelter.jQuery = window.jQuery
Stelter.log = window.log = []

Stelter.jQuery( jQuery => {

    // Adobe Launch check
    window.isAdobeLaunch = typeof window._satellite !== 'undefined' && localStorage.getItem('Stl_NoAnalytics') === null && localStorage.getItem('Stl_OptOut') === null && !window.location.search.includes('stl_optout=1') || (typeof window._satellite !== 'undefined' && window.location.search.includes('stl_optout=0'));
    window.isNoAnalytics = (typeof window.isNoAnalytics !== 'undefined' && window.isNoAnalytics.toString() === 'true') || window.location.search.includes('stl_optout=1') || document.cookie.includes('Stl_NoAnalytics') || document.cookie.includes('Stl_OptOut') || localStorage.getItem('Stl_NoAnalytics') || localStorage.getItem('Stl_OptOut');

    // replace GI 1.0 links/iframes
    Stelter.giftIllustratorTwoRedirect = () => {
        var orgIdValue = window.orgId || '';
        const valuesToSearchFor = ['web.giftillustrator.com/Calculator/Production/cga', 'web.giftillustrator.com/Calculator/Production/secondary2', 'web.giftillustrator.com/Calculator/Production/secondary1', 'web.giftillustrator.com/Calculator/Production/og', 'web.giftillustrator.com/Calculator/Production/home', 'web.giftillustrator.com/Calculator/Production/rle', 'web.giftillustrator.com/Calculator/Production/dcga', 'web.giftillustrator.com/Calculator/Production/bs', 'web.giftillustrator.com/Calculator/Production/crut']

        const curriedLinkLookup = (value) => {
            return Array.from(document.querySelectorAll(`a[href*="${value}"],iframe[src*="${value}"]`))
        }

        valuesToSearchFor.forEach(value => {
            if(curriedLinkLookup(value).length > 0 ){
                curriedLinkLookup(value).forEach(link => {
                    if (orgIdValue === '') {
                        if (link.tagName === 'A' && link.href.toLowerCase().includes('orgid=')) {
                            orgIdValue = link.href.toLowerCase().split('orgid=')[1].split('&')[0]
                        }
                        if (link.tagName === 'IFRAME' && link.src.toLowerCase().includes('orgid=')) {
                            orgIdValue = link.src.toLowerCase().split('orgid=')[1].split('&')[0]
                        }
                    }

                    orgIdValue = orgIdValue.toUpperCase()

                    const valueToNewURL = {
                        /* eslint-disable */
                        'web.giftillustrator.com/Calculator/Production/cga': 'https://calculator.giftillustrator.com/' + orgIdValue + '/gift-annuity',
                        'web.giftillustrator.com/Calculator/Production/secondary2': 'https://calculator.giftillustrator.com/' + orgIdValue + '/lead-trust',
                        'web.giftillustrator.com/Calculator/Production/secondary1': 'https://calculator.giftillustrator.com/' + orgIdValue + '/charitable-remainder-trust',
                        'web.giftillustrator.com/Calculator/Production/og': 'https://calculator.giftillustrator.com/' + orgIdValue + '/outright-gift',
                        'web.giftillustrator.com/Calculator/Production/home': 'https://calculator.giftillustrator.com/' + orgIdValue,
                        'web.giftillustrator.com/Calculator/Production/rle': 'https://calculator.giftillustrator.com/' + orgIdValue + '/retained-life-estate',
                        'web.giftillustrator.com/Calculator/Production/dcga': 'https://calculator.giftillustrator.com/' + orgIdValue + '/gift-annuity',
                        'web.giftillustrator.com/Calculator/Production/bs': 'https://calculator.giftillustrator.com/' + orgIdValue + '/bargain-sale',
                        'web.giftillustrator.com/Calculator/Production/crut': 'https://calculator.giftillustrator.com/' + orgIdValue + '/charitable-remainder-trust'
                        /* eslint-enable */
                    }

                    var newUrl = valueToNewURL[value];
                    if (link.tagName === 'A') link.href = newUrl
                    if (link.tagName === 'IFRAME') link.src = newUrl
                })
            }
        })
    }

    Stelter.giftIllustratorTwoRedirect()

    // External link clicks
    if (isAdobeLaunch) {
        var subIdValue = window.location.search.includes('subid=') ? window.location.search.split('subid=')[1].split('&')[0] : typeof stlDigitalData !== 'undefined' && typeof stlDigitalData.user !== 'undefined' && typeof stlDigitalData.user.profile !== 'undefined' && typeof stlDigitalData.user.profile.subId !== 'undefined' ? stlDigitalData.user.profile.subId : '';
        var mcmid = typeof _satellite !== 'undefined' && typeof _satellite.getVisitorId() !== 'undefined' && typeof _satellite.getVisitorId()._fields !== 'undefined' && typeof _satellite.getVisitorId()._fields.MCMID !== 'undefined' ? _satellite.getVisitorId()._fields.MCMID : '';
        var pageLinks = document.querySelectorAll('a');
        pageLinks.forEach(function(link){
            var host = window.location.hostname;

            if(link.firstChild === link.lastChild && link.textContent.indexOf('"') > -1) {
                // double quotes in link text will break tracking, so replace them with curly quotes
                var content = link.textContent;
                content = content.replace(/"(?=\w|$^")/g, "“");
                content = content.replace(/"/g, "”");
                link.textContent = content;
            }

            if(link.href.length > 0 
                && link.href.indexOf(host) === -1 
                && link.href.indexOf('mailto:') === -1 
                && link.href.indexOf('tel:') === -1
                && link.href.indexOf('#') === -1
                && link.href.indexOf('javascript:') === -1
                && link.href.indexOf('giftillustrator.com') === -1
                && (typeof link.target !== 'undefined' && link.target !== '_blank')
            ) {
                link.addEventListener('click',function(){
                    _satellite.track("site.exit",{"site":link.href});
                });
                link.addEventListener('keydown',function(){
                    _satellite.track("site.exit",{"site":link.href});
                });
            }

            if(link.href.indexOf('calculator.giftillustrator.com') > -1) {
                var giUrl = link.href;
                
                if(giUrl.indexOf('subid=') === -1) {
                    document.cookie.split('; ').forEach(function(c) {
                        if(subIdValue === '' && c.startsWith('Stl_SubId')) {
                            subIdValue = c.split('=')[1]
                        }
                    })
                    if(subIdValue !== '') {
                        giUrl = giUrl.indexOf('?') > -1 ? giUrl + '&subid=' + subIdValue : giUrl + '?subid=' + subIdValue 
                    }
                }

                if (giUrl.indexOf('adobe_mc') === -1 && mcmid !== '') {
                    giUrl = giUrl.indexOf('?') > -1 ? giUrl + '&adobe_mc=MCMID=' + mcmid : giUrl + '?adobe_mc=MCMID=' + mcmid 
                }

                link.href = giUrl;
            }

            if(link.href.indexOf('mailto:') > -1) {
                // configured in launch
            }
            if(link.href.indexOf('tel:') > -1) {
                // configured in launch
            }
        });

        var giFrames = document.querySelectorAll('iframe[src*="calculator.giftillustrator.com"]');
        giFrames.forEach(function(frame) {
            var giUrl = frame.src;

            if(giUrl.indexOf('subid=') === -1) {
                document.cookie.split('; ').forEach(function(c) {
                    if(subIdValue === '' && c.startsWith('Stl_SubId')) {
                        subIdValue = c.split('=')[1]
                    }
                })
                if(subIdValue !== '') {
                    giUrl = giUrl.indexOf('?') > -1 ? giUrl + '&subid=' + subIdValue : giUrl + '?subid=' + subIdValue 
                }
            }

            if (giUrl.indexOf('adobe_mc') === -1 && mcmid !== '') {
                giUrl = giUrl.indexOf('?') > -1 ? giUrl + '&adobe_mc=MCMID=' + mcmid : giUrl + '?adobe_mc=MCMID=' + mcmid 
            }

            frame.src = giUrl;
        })
    } else if (isNoAnalytics) {
        var noAnalyticsGiLinks = document.querySelectorAll('a[href*="calculator.giftillustrator.com"]');
        noAnalyticsGiLinks.forEach(function(link){
            var giUrl = link.href;
            if (giUrl.indexOf('stl_analytics=') === -1) {
                giUrl = giUrl.indexOf('?') > -1 ? giUrl + '&stl_analytics=false' : giUrl + '?stl_analytics=false'
            }
            link.href = giUrl;
        });

        var noAnalyticsGiFrames = document.querySelectorAll('iframe[src*="calculator.giftillustrator.com"]');
        noAnalyticsGiFrames.forEach(function(frame) {
            var giUrl = frame.src;
            if (giUrl.indexOf('stl_analytics=') === -1) {
                giUrl = giUrl.indexOf('?') > -1 ? giUrl + '&stl_analytics=false' : giUrl + '?stl_analytics=false'
            }
            frame.src = giUrl;
        })
    }

    // consent notice and policy functions
    var displayConsent = function () {
        window.consentPop = localStorage.getItem('stlConsentPop');
        // check if the consent popup has been displayed
        if(!window.consentPop){
            var site = window.location.hostname;
            var siteControlParam = site.indexOf('ingeniuxondemand.com') > -1 ? "?sitecontrol=" + pageId : "";
            var consentWrapper = '<div id="stl-cookie-consent" role="dialog" aria-live="assertive" aria-describedby="stl-consent-desc" class="stl-consent-dialog stl-consent-show"></div>';
            document.body.insertAdjacentHTML('afterbegin',consentWrapper);
            var ccDialog = document.getElementById('stl-cookie-consent');
            if(ccDialog !== null)  {
                var consentContent = '<div class="stl-consent-wrapper"><p id="stl-consent-desc" class="stl-consent-message" tabindex="0">By continuing to access this website, you agree to our use of cookies, which help us understand who visits our website and how they use it. Read our <a class="stl-consent-link" href="/privacy-policy'+siteControlParam+'">privacy notice</a> for further&nbsp;details.</p><span role="button" aria-label="close popup and accept cookies" tabindex="0" class="stl-consent-close stl-consent-allow">&times;</span></div>';
                ccDialog.insertAdjacentHTML('beforeend',consentContent);
                // notice has been displayed
                localStorage.setItem('stlConsentPop','Displayed');
                // if (isAdobeLaunch) {
                //     _satellite.track("site_tool.interaction",{"toolName":site+": Cookie Notice Displayed"});
                // } 
                
                var trkNoticePolicyLink = function (e) {
                    if(a11yClick(e)) {
                        // user clicked to learn more
                        if (isAdobeLaunch) {
                            _satellite.track("site_tool.interaction",{"toolName":site+": Cookie Notice Policy Link"});
                        } 
                    }
                }
                var trkNoticeCloseLink = function (e) {
                    if(a11yClick(e)) {
                        if(localStorage.getItem('dnt') !== null) localStorage.removeItem('dnt');
                        ccDialog.classList.remove('stl-consent-show');
                        // user clicked close
                        if (isAdobeLaunch) {
                            _satellite.track("site_tool.interaction",{"toolName":site+": Cookie Notice Close"});
                        } 
                    }
                }

                ccDialog.querySelector('.stl-consent-link').addEventListener('click',trkNoticePolicyLink,false);
                ccDialog.querySelector('.stl-consent-link').addEventListener('keydown',trkNoticePolicyLink,false);
                ccDialog.querySelector('.stl-consent-allow').addEventListener('click',trkNoticeCloseLink,false);     
                ccDialog.querySelector('.stl-consent-allow').addEventListener('keydown',trkNoticeCloseLink,false);     
            }
        }

        if(document.querySelector('.stl-copyright') !== null && document.querySelectorAll('.stl-copyright .stl-policy-links a').length === 0) {
            document.querySelector('.stl-copyright').insertAdjacentHTML('beforeend',`<span class="stl-policy-links" style="display: none;"><a href="privacy-policy">Privacy Policy</a> | <a href="cookie-policy">Cookie Policy</a></span>`);
        }
    }
    var showSpecificPolicyInfo = function () {
        // depending on the client site, there will be different cookie information to display on the cookie notice page
        var cookiePage = document.querySelector('.syndicated.cookie-policy-copy');
        if(cookiePage !== null){
            // detect google analytics
            if(typeof ga === 'function' || typeof gtag === 'function') cookiePage.querySelector('.specific-cookie-notice[data-cookieName="GoogleAnalytics"]').classList.add('show');
            // detect capture
            if(typeof _cbe === 'function') cookiePage.querySelector('.specific-cookie-notice[data-cookieName="Capture"]').classList.add('show');
            // detect facebook pixel
            if(typeof fbq === 'function') cookiePage.querySelector('.specific-cookie-notice[data-cookieName="FacebookPixel"]').classList.add('show');
            // detect twitter remarketing
            if(typeof twq === 'function') cookiePage.querySelector('.specific-cookie-notice[data-cookieName="Twitter"]').classList.add('show');
            // detect others
            
            // remove rest
            var naCookies = document.querySelectorAll('.specific-cookie-notice:not(.show)');
            naCookies.forEach(function(section){
                section.remove();
            })

            if(document.querySelectorAll('.cookie-section-clients .specific-cookie-notice.show').length > 0) {
                document.querySelector('.cookie-section-clients').classList.remove('hide')
            } else {
                document.querySelector('.cookie-section-clients').remove()
            }
        }
    }

    if(typeof showConsent !== "undefined" && useRewrites == "True" && !isNoAnalytics) {
        displayConsent();
    } else {
        if(document.querySelectorAll('.stl-policy-links').length) {
            document.querySelectorAll('.stl-policy-links').forEach(el => el.remove())
        }
    }
    showSpecificPolicyInfo();

    if(document.querySelectorAll('.stl-policy-links a, .stl-policy-engaged-link').length && useRewrites == "False"){
        document.querySelectorAll('.stl-policy-links a, .stl-policy-engaged-link').forEach(function(link){
            var linkLocation = link.classList.contains("stl-policy-engaged-link") ? "Policy Page Engaged" : "Disclaimer";
            if(useRewrites == "False"){
                link.href = link.href + "?sitecontrol=" + pageId;
            }
            var trkPolicyEngagedLinks = function (e) {
                if(a11yClick(e)) {
                    // user clicked policy link in copy
                    if (isAdobeLaunch) {
                        _satellite.track("site_tool.interaction",{"toolName": window.location.hostname + ": Policy Link - " + linkLocation});
                    }
                }
            }
            link.addEventListener('click',trkPolicyEngagedLinks,false);
            link.addEventListener('keydown',trkPolicyEngagedLinks,false);
        })
    }

    var displayCARES = function () {
        if(window.localStorage.getItem(orgId + 'caresNotice') !== null) window.localStorage.removeItem(orgId + 'caresNotice');
        var caresRequest = new XMLHttpRequest()
        var caresMessage = "";
        caresRequest.open('GET', window.location.protocol+"//"+window.location.host+'/cares-act-popup?clear=true', true)
        caresRequest.responseType = 'document'
        caresRequest.overrideMimeType('text/html')
        caresRequest.onload = () => {
            if (caresRequest.readyState === caresRequest.DONE) {
                if (caresRequest.status === 200) {
                    var content = caresRequest.responseXML;
                    caresMessage = content.getElementById('cares-act-popup-copy').innerHTML;
                    
                    var caresNoticeHTML = '<style>#caresNotice a{color:#fff !important; text-decoration:underline !important;}#caresNotice a:hover, #caresNotice a:focus{text-decoration:none !important;}.d-flex {display: -webkit-box !important;display: flex !important}.flex-justify-between {-webkit-box-pack: justify !important;justify-content: space-between !important}.flex-items-center {-webkit-box-align: center !important;align-items: center !important}.mx-auto {margin-right: auto !important;margin-left: auto !important}.d-none {display: none !important}.d-sm-inline-block {display: inline-block !important}.text-white {color: #fff !important;}.f5 {font-size: 14px !important;}.bg-black {background-color: rgba(0, 0, 0, 0.95) !important;}.stl-cares-close {display: inline-block;vertical-align: text-bottom;fill: currentColor;}#caresNotice {font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"; font-size:16px !important; line-height:1.5 !important; position: relative;top: 0;left: 0;right: 0;padding: 16px !important;z-index: 999999;}#closeButton {display: inline-block;padding: 0;font-size: inherit;color: #0366d6;text-decoration: none;white-space: nowrap;cursor: pointer;-webkit-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;background-color: transparent;border: 0;-webkit-appearance: none;-moz-appearance: none;appearance: none;padding: 8px !important;margin-left: 4px !important;}.sr-only {position: absolute;width: 1px;height: 1px;padding: 0;overflow: hidden;clip: rect(0, 0, 0, 0);word-wrap: normal;border: 0;}#stl-cares-learn-more {position: relative;display: inline-block;padding: 6px 12px;font-size: 14px;font-weight: 600;line-height: 20px;white-space: nowrap;vertical-align: middle;cursor: pointer;-webkit-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;background-repeat: repeat-x;background-position: -1px -1px;background-size: 110% 110%;border: 1px solid rgba(27, 31, 35, 0.2);border-radius: 0.25em;-webkit-appearance: none;-moz-appearance: none;appearance: none;color: #24292e;background-color: #eff3f6;background-image: linear-gradient(-180deg, #fafbfc 0%, #eff3f6 90%);text-decoration: none;}#stl-cares-learn-more:hover {background-color: #e6ebf1;background-image: linear-gradient(-180deg, #f0f3f6 0%, #e6ebf1 90%);background-position: 0 -0.5em;border-color: rgba(27, 31, 35, 0.35);}#stl-contact-us-link {color: white;}</style> <div id="caresNotice" class="py-2 px-3 f5 text-white bg-black rounded-0"> <div class="d-flex flex-justify-between flex-items-center mx-auto" style="max-width: 980px;"><div><strong></strong> <span class="d-none d-sm-inline-block">' + caresMessage + '</span> </div> <button id="closeButton" type="button" class="btn-link text-white p-2 ml-1"> <svg aria-hidden="true" class="stl-cares-close" focusable="false" height="16" version="1.1" viewBox="0 0 12 16" width="12"><path fill-rule="evenodd" d="M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48z"></path></svg> <span class="sr-only">Dismiss</span> </button> </div> </div>';
                    
                    if(document.getElementById('caresNotice') === null) document.body.insertAdjacentHTML('afterbegin', caresNoticeHTML)

                    var trkCaresCloseLink = function (e) {
                        if(a11yClick(e)) {
                            e.stopPropagation();
                            document.getElementById('caresNotice').style.display = 'none';
                            window.sessionStorage.setItem(orgId + 'caresNotice', !0)
                            // user clicked close
                            if (isAdobeLaunch) {
                                _satellite.track("site_tool.interaction",{"toolName": window.location.hostname + ": CARES Banner Close"});
                            } 
                        }
                    };
                    var trkCaresArticleLink = function (e) {
                        if(a11yClick(e)) {
                            e.stopPropagation();
                            document.getElementById('caresNotice').style.display = 'none';
                            // clicking article link will not close the banner for the session this time
                            // window.sessionStorage.setItem(orgId + 'caresNotice', !0)
                            // user clicked article link
                            if (isAdobeLaunch) {
                                _satellite.track("site_tool.interaction",{"toolName": window.location.hostname + ": " + e.target.dataset.sitetool });
                            } 
                        }
                    };

                    document.getElementById('closeButton').addEventListener('click',trkCaresCloseLink,false);
                    document.getElementById('closeButton').addEventListener('keydown',trkCaresCloseLink,false);
                    if (document.querySelector('#caresNotice .cares-article-link')) {
                        document.querySelector('#caresNotice .cares-article-link').addEventListener('click',trkCaresArticleLink,false);     
                        document.querySelector('#caresNotice .cares-article-link').addEventListener('keydown',trkCaresArticleLink,false); 
                    }
                    if (document.querySelector('#caresNotice .contactEMAddr')) { 
                        document.querySelector('#caresNotice .contactEMAddr').addEventListener('click', function (e) {
                            e.stopPropagation()
                            var thisEMAddr = document.querySelector('#caresNotice .contactEMAddr')
                            let uname = thisEMAddr.dataset.uname.trim()
                            let domain = thisEMAddr.dataset.domain.trim()
                            let email = `mailto:${uname}@${domain}`
                            window.location.href = email
                        })
                    }
                }
            }
        }
        caresRequest.send(null);
    }

    // CARES Act banner function commented out 1/3/2022
    // if(!window.sessionStorage.getItem(orgId + 'caresNotice') && useRewrites == "True" && (typeof customCARES === "undefined" || customCARES == false)) displayCARES();

    // Video tracking 
    // -----------------------------------------------------------------
    function videoTracker(e) {
        var video = e.target;
        var url = video.src !== null ? video.src : video.querySelector('source') !== null ? video.querySelector('source').src : '';
        var mediaName = video.getAttribute('title');
        if (mediaName === null || mediaName.toString().trim() === '') {
            // if no title attribute, build the title from the URL
            var mediaPath = url.split('/').pop();
            let fileName = mediaPath.split('.');
            fileName.pop()
            var lowerTitle = fileName.join(' ').replaceAll('-',' ')
            // capitalize each word in the title
            mediaName = lowerTitle.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
        }
        var mediaLength = video.duration;
        var mediaPlayerName = "HTML5 Basic Player";
        var mediaOffset;
        var videoAction = "";
    
        // Define video offset
        if (video.currentTime > 0) {
            mediaOffset = Math.floor(video.currentTime);
        } else {
            mediaOffset = 0;
        }
    
        if (e.type == "play") {
            videoAction = "view";
            if (isNaN(mediaLength)) {
                // no duration available yet, wait until enough video data is available
                video.oncanplay = () => {
                    _satellite.track("video",{
                        "videoAction":videoAction,
                        "videoPlayer":mediaPlayerName, 
                        "videoTitle":mediaName,
                        "videoDuration":video.duration,  // pass as integer
                        "mediaOffset":mediaOffset  // pass as integer
                    });
                }
            } else {
                _satellite.track("video",{
                    "videoAction":videoAction,
                    "videoPlayer":mediaPlayerName, 
                    "videoTitle":mediaName,
                    "videoDuration":mediaLength,  // pass as integer
                    "mediaOffset":mediaOffset  // pass as integer
                });
            }
        } else if (e.type == "pause") {
            videoAction = "pause";
            _satellite.track("video",{
                "videoAction":videoAction,
                "videoPlayer":mediaPlayerName, 
                "videoTitle":mediaName,
                "videoDuration":mediaLength,  // pass as integer
                "mediaOffset":mediaOffset  // pass as integer
            });
        } else if (e.type == "ended") {
            videoAction = "complete";
            video.load();
            _satellite.track("video",{
                "videoAction":videoAction,
                "videoPlayer":mediaPlayerName, 
                "videoTitle":mediaName,
                "videoDuration":mediaLength,  // pass as integer
                "mediaOffset":mediaOffset  // pass as integer
            });
        } else if (e.type == "ontimeupdate") {
            //video.ontimeupdate = (event) => {
            var currentTime = video.currentTime;
            // 25%
            if (currentTime >= (mediaLength * 0.25) && !window.complete_25) {
            // console.log("VIDEO 25% COMPLETE");
                _satellite.track("video",{
                    "videoAction":"25",
                    "videoPlayer":mediaPlayerName, 
                    "videoTitle":mediaName,
                    "videoDuration":mediaLength,  // pass as integer
                    "mediaOffset":mediaOffset  // pass as integer
                });
                window.complete_25 = true;
            }
            // 50%
            else if (currentTime >= (mediaLength * 0.5) && !window.complete_50) {
            // console.log("VIDEO 50% COMPLETE");
                _satellite.track("video",{
                    "videoAction":"50",
                    "videoPlayer":mediaPlayerName, 
                    "videoTitle":mediaName,
                    "videoDuration":mediaLength,  // pass as integer
                    "mediaOffset":mediaOffset  // pass as integer
                });
                window.complete_50 = true;
            }
            // 75%
            else if (currentTime >= (mediaLength * 0.75) && !window.complete_75) {
            // console.log("VIDEO 75% COMPLETE");
                _satellite.track("video",{
                    "videoAction":"75",
                    "videoPlayer":mediaPlayerName, 
                    "videoTitle":mediaName,
                    "videoDuration":mediaLength,  // pass as integer
                    "mediaOffset":mediaOffset  // pass as integer
                });
                window.complete_75 = true;
            }
            return false;
        }
    }

    if(document.querySelector('video') !== null) {
        document.querySelectorAll('video').forEach(video => {
            // don't track backend videos that have script directly after
            if(video.nextElementSibling === null || video.nextElementSibling.tagName !== 'SCRIPT') {
                // % complete tracking
                window.complete_25 = false;
                window.complete_50 = false;
                window.complete_75 = false;
                if(isAdobeLaunch) { 
                    // Launch video tracking
                    video.addEventListener("play", videoTracker, false);
                    video.addEventListener("ended", videoTracker, false);
                    video.addEventListener("timeupdate", videoTracker, false);
                }
            }
        });
    }

    var displayGlobalPopup = function () {
        // set if the article is about CGAs or DAFs
        let isCGA = false;
        let isDAF = false;
        var currDate = window.popupTestCurrDate || new Date();
        // use UTC date for specific start datetime, others are relative to visitor's timezone
        var noticeStartDate = window.popupTestDate || new Date('2026-10-19T00:00:00.000Z'); 
        var noticeEndDate1 = new Date('10/25/2026 23:58');
        //var noticeEndDate2 = (typeof bannerEndDate !== "undefined" && bannerEndDate !== null) ? new Date(bannerEndDate) : new Date('10/08/2026 23:59')
        var inDateRange = false;
        var showBannerPage = false;
        // only show the banner if the page is a home page, article page, interior page, or contact us page
        if ((document.body.id == 'home-page' || 
            document.body.classList.contains("home-page") || 
            document.body.classList.contains("HomePage") ||
            document.querySelector('.stl-journey-paths') !== null || 
            document.querySelector('.stl_clientMissionBody') !== null ||  
            document.body.classList.contains('article-page') || 
            document.body.classList.contains('Article') ||
            document.body.classList.contains('interior-page') ||
            document.body.classList.contains('InteriorPage') ||
            document.body.classList.contains('contact-page') ||
            document.body.classList.contains('contact-us') ||
            document.body.classList.contains('ContactUsPage') ||
            typeof document.forms.brochureform !== "undefined") &&
            !document.body.classList.contains('landing-page') &&
            !document.body.classList.contains('LandingPageClean')) {
                showBannerPage = true;
        }

        if (currDate >= noticeStartDate && currDate < noticeEndDate1) {
            inDateRange = true; // date between total range 
        }

        if(inDateRange && showBannerPage){
            // If popup is for CGA, check if site excludes CGA. Combined banner won't use this check
            if (isCGA) {
                document.body.insertAdjacentHTML('beforeend','<div id="cga-check" class="ge-cga ge-dcga" aria-hidden="true" style="display:inline"></div>');
                var excludeCGA = getComputedStyle(document.getElementById('cga-check')).getPropertyValue('display') === "none";
                if (excludeCGA) {
                    // site excludes CGA, do not show popup
                    sessionStorage.setItem(orgId+'globalPopup','true');
                    return;
                } 
            }
            var dafUrl = null;
            // If popup is for DAF, check if site excludes DAF. Combined banner won't use this check
            if (isDAF) {
                document.body.insertAdjacentHTML('beforeend','<div id="daf-check" class="ge-daf" aria-hidden="true" style="display:inline"></div>');
                var excludeDAF = getComputedStyle(document.getElementById('daf-check')).getPropertyValue('display') === "none";
                var dafUrlExists = document.querySelector('a[href*="donor-advised-funds"]') !== null;
                if (excludeDAF || !dafUrlExists) {
                    // site excludes DAF, do not show popup
                    sessionStorage.setItem(orgId+'globalPopup','true');
                    return;
                } else {
                    dafUrl = dafUrlExists ? document.querySelector('a[href*="donor-advised-funds"]').href : null
                }
            }
            
            var bannerMaxWidth = '1200px';
            var paddingLeft = 15;
            var paddingRight = 15;
            if (document.querySelector('header .container') !== null) {
                var container = document.querySelector('header .container');
                var maxWidth = getComputedStyle(container).maxWidth;
                paddingLeft = parseInt(getComputedStyle(container).paddingLeft, 10);
                paddingRight = parseInt(getComputedStyle(container).paddingRight, 10);
                // if max-width is not set, use the default value
                if (maxWidth !== 'none' && maxWidth !== '') {
                    if((maxWidth.endsWith('%') && parseInt(maxWidth, 10) > 80) || (maxWidth.endsWith('px') && parseInt(maxWidth, 10) > 1000)) {
                        bannerMaxWidth = maxWidth;
                    }
                }
            }

            paddingLeft = paddingLeft + 'px'; // convert to string with px
            paddingRight = paddingRight + 'px'; // convert to string with px    

            var htmlClass = document.documentElement.classList;
            //var dash = htmlClass.contains('emdash') ? '&mdash;' : htmlClass.contains('emdash-spaces') ? ' &mdash; ' : htmlClass.contains('endash') ? '&ndash;' : htmlClass.contains('endash-spaces') ? ' &ndash; ' : '&mdash;';
            var btnText = htmlClass.contains('sentence-case') ? 'helpful guide' : 'helpful guide ';
            var btnTextb = htmlClass.contains('sentence-case') ? 'you can make an impact quickly' : 'you can make an impact quickly'; //two links within the same banner
            var btnText2 = htmlClass.contains('sentence-case') ? 'recommending a distribution' : 'recommending a distribution';
            var btnText2b = htmlClass.contains('sentence-case') ? 'Learn all about' : 'Learn all about'; //two links within the same banner
            var popupCopy = '';
            var btnURL = siteControlTier.includes('Standard') ||
                         siteControlTier.includes('SDS Guides') ||
                         siteControlTier.includes('Plus') ? '/estate-planning-at-home-guide' : '/ebrochure-page?ebr=x77';
                         //siteControlTier.includes('Plus') ? dafUrl : dafUrl;

            var gdClient = document.querySelector('a[href*="giving-docs"]') !== null || document.querySelector('a[href*="givingdocs.com"]') !== null;
            var gdURL = gdClient ? (document.querySelector('a[href*="giving-docs"]') || document.querySelector('a[href*="givingdocs.com"]')).href : '';

            if(currDate >= noticeStartDate && currDate < noticeEndDate1) {
                // date between 10/09/26 and 10/25/26, show version 1 content
                var title1 = htmlClass.contains('sentence-case') ? 'It&rsquo;s Estate Planning Awareness Week! ' : 'It&rsquo;s Estate Planning Awareness Week! ';
                popupCopy = '<p><strong id="stl-announcement__title">'+ title1 +'</strong> <span id="stl-announcement__description">' + 'Now is the perfect time to make a plan that ensures your wishes are followed and your loved ones (and loved causes) are cared for. Download our <a href="' + btnURL + '" id="stl-announcement__article-link" class="stl-announcement-link">' + btnText + '</a> to get started.</span></p>';

                //no giving docs for DAF day
                // if (gdClient && gdURL !== '') {
                //     btnText = 'a safe, secure tool';
                //     popupCopy = '<p><strong id="stl-announcement__title">'+ title1 +'</strong> <span id="stl-announcement__description">' + 'We have <a href="' + gdURL + '" id="stl-announcement__article-link" class="stl-announcement-link">' + btnText + '</a> you can use to create your estate plan so you can protect the people and causes you&nbsp;love.' + '</span></p>';
                // }
            }
            // if(currDate >= noticeEndDate1 && currDate < noticeEndDate2) {
            //     // date between 10/7/26 and 10/08/26, show version 2 content
            //     var title2 = htmlClass.contains('sentence-case') ? 'Today is DAF Day! ' : 'Today is DAF Day! ';
            //     popupCopy = '<p><strong id="stl-announcement__title">'+ title2 +'</strong> <span id="stl-announcement__description">You can join the celebration by <a href="' + btnURL + '" id="stl-announcement__article-link" class="stl-announcement-link">' + btnText2 + '</a> from your DAF. Don\'t have a donor advised fund? <a href="' + btnURL + '" id="stl-announcement__article-link" class="stl-announcement-link">' + btnText2b + '</a> this amazing charitable tool.</span></p>';
            // }

            var noticeHTML = `<style>.stl-announcement-banner {font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"; font-size:16px !important; line-height:1.5 !important; padding: 20px 0; background-color: rgba(0, 0, 0, 0.95) !important; z-index: 999999;} .stl-announcement-banner.top-banner {position: relative; top: 0; left: 0; right: 0; } .stl-announcement-banner .stl-announcement-container {display: flex; justify-content: space-between; align-items: flex-start; max-width: ${bannerMaxWidth}; margin: 0 auto; padding-left: ${paddingLeft}; padding-right: ${paddingRight}} .stl-announcement-banner p {color: #fff !important; margin: 0 !important;} .stl-announcement-banner p + p {margin-top:0.75em !important;} .stl-announcement-banner .stl-announcement-link {color:#fff !important; text-decoration:underline !important;} .stl-announcement-banner .stl-announcement-link:hover, .stl-announcement-banner .stl-announcement-link:focus {text-decoration:none !important;} .stl-announcement-close {display: inline-block; font-size: inherit; color: inherit; text-decoration: none;white-space: nowrap;cursor: pointer;-webkit-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;background-color: transparent;border: 0;appearance: none;padding: 8px !important; margin: -6px 0 0 30px !important;} .stl-announcement-banner .stl-close-svg {display: inline-block; vertical-align: text-bottom; fill: #fff; width: 15px; height: 20px;} .sr-only {position: absolute;width: 1px;height: 1px;padding: 0;overflow: hidden;clip: rect(0, 0, 0, 0);word-wrap: normal;border: 0;}</style> <div id="stl-announcement__top-banner" class="stl-announcement-banner top-banner" role="dialog" aria-labelledby="stl-announcement__title" aria-describedby="stl-announcement__description"> <div class="stl-announcement-container"> <div class="stl-announcement-content">${popupCopy}</div> <button id="stl-announcement__close-btn" type="button" class="stl-announcement-close"><svg aria-hidden="true" class="stl-close-svg" focusable="false" tabindex="-1" height="16" version="1.1" viewBox="0 0 12 16" width="12"><path focusable="false" tabindex="-1" fill-rule="evenodd" d="M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48z"></path></svg><span class="sr-only">Dismiss</span></button></div></div>`;

            document.body.insertAdjacentHTML('afterbegin',noticeHTML);

            // set banner height data attribute
            var bannerHeight = document.getElementById('stl-announcement__top-banner').offsetHeight;
            if(typeof getBannerHeight !== 'undefined' && document.getElementById('stl-cms') !== null) document.getElementById('stl-cms').style.paddingTop = bannerHeight + 'px';
            var bannerResizeTimer;
            window.onresize = () => {
                clearTimeout(bannerResizeTimer);
                bannerResizeTimer = setTimeout(() => {
                    var newBannerHeight = document.getElementById('stl-announcement__top-banner').offsetHeight;
                    if(typeof getBannerHeight !== 'undefined' && document.getElementById('stl-cms') !== null) document.getElementById('stl-cms').style.paddingTop = newBannerHeight + 'px';   
                }, 250);
            };

            var trkCloseLink = function (e) {
                if(a11yClick(e)) {
                    e.stopPropagation();
                    document.getElementById('stl-announcement__top-banner').remove();
                    sessionStorage.setItem(orgId+'globalPopup','true');
                    if (isAdobeLaunch) {
                        _satellite.track('site_tool.interaction',{'toolName': '2026 Estate Planning Awareness Week - Close Button' });
                    } 
                }
            };
            var trkArticleLink = function (e) {
                if(a11yClick(e)) {
                    e.stopPropagation();
                    // uncomment the next line if the banner should not close when article link is clicked
                    // sessionStorage.setItem(orgId+'gobalPopup','true');
                    if (isAdobeLaunch) {
                        _satellite.track('site_tool.interaction',{'toolName': '2026 Estate Planning Awareness Week - Banner Article Link' });
                    } 
                }
            };

            document.getElementById('stl-announcement__close-btn').addEventListener('click',trkCloseLink,false);
            document.getElementById('stl-announcement__close-btn').addEventListener('keydown',trkCloseLink,false);
            document.getElementById('stl-announcement__article-link').addEventListener('click',trkArticleLink,false);     
            document.getElementById('stl-announcement__article-link').addEventListener('keydown',trkArticleLink,false); 

        } else {
            if(sessionStorage.getItem(orgId+'globalPopup') !== null) sessionStorage.removeItem(orgId+'globalPopup');
        }
    }
    if(!sessionStorage.getItem(orgId+'globalPopup') && !localStorage.getItem(orgId+'globalPopup') && useRewrites === "True" && typeof noGlobalPopup === "undefined") {
        displayGlobalPopup();
    }

    Stelter.isNullOrWhiteSpace = value => value === null || value === '' || String(value).trim() === '' || value === undefined || value == 'undefined' ||value === 'undefined' ? true : false

    Stelter.setHTMLClassTag = () => {
        if(!document.getElementsByTagName('html')[0].classList.contains(window.serverIs)) {
            document.getElementsByTagName('html')[0].classList.add(window.serverIs)
        }
    }

    // This also removes download option in Chrome
    Stelter.addVideoCaptions = () => {
        try {
            let video = document.getElementById('stl-video-tag')
            if(video){
                // sourceURI contains leading /
                let sourceURI = video.src.slice(video.src.lastIndexOf('/'),video.src.lastIndexOf('.'))
                // assetDirectory does NOT contain trailing /
                let assetDirectory = window.serverIs == 'preview' ? '/DSSPreview/Media/Stelter/global/videos/captions' : 'Media/Stelter/global/videos/captions'
                if(document.querySelector('#stl-video-tag track') == null){
                    let track = document.createElement('track')
                    track.kind = 'captions'
                    track.label = 'English'
                    track.srclang = 'en'
                    track.src = assetDirectory + sourceURI + '.en.vtt'
                    video.appendChild(track)
                } 
            }
        } catch (error) {
            window.log ? window.log += `\n${error}` : window.log = error
        }
    }

    Stelter.removeVideoDownloadButton = () => {
        try{
            let video = document.getElementById('stl-video-tag')
            if(video){
                video.controlsList = 'nodownload'
            }
        }catch(error){
            window.log ? window.log += `\n${error}` : window.log = error
        }
    }

    Stelter.setBodyId = () => {
        if (!document.querySelectorAll(`body`)[0].id) {
            let pageId = `${window.location.pathname.split('/').pop()}-page`
            // If we're on the homepage then we'll need to build the ID from the host (for live sites)
            if(pageId == `-page`) {
                let hostString = window.location.host.split('.')
                let subDomain = hostString[0]
                let domain = hostString[1]
                pageId = `${subDomain}-${domain + pageId}`
                document.body.id = pageId
            }
            else {
                document.body.id = pageId
            }
        }
    }

    // Remove empty tags
    Stelter.removeEmpties = () => {
        jQuery('h2,h3').filter(function() {
            return jQuery(this).text().trim().length == 0
        }).remove()
        if (jQuery('.stl_ContactWebsite a').is(':empty') === true) {
            jQuery('.stl_ContactWebsite a:empty').parents('.stl_ContactWebsite').remove()
        }
    }
    
    Stelter.uberLoadDomains = (url) => {
        var rawFile = new XMLHttpRequest();
        rawFile.onload = () => {
            if (rawFile.readyState === 4) {
                if (rawFile.status === 200 || rawFile.status === 0) {
                    var domainString = rawFile.responseText;
                    var domainList = domainString.split('\n');
                    var disclaimerCGAText = `<p class="ebro-form-disclaimer"><small>*Figures cited in this document’s examples are for hypothetical purposes only and are subject to change.</small></p>`;
                    if (domainList.indexOf(window.location.host) == -1) {
                        [].slice.call(document.querySelectorAll('#brochureform')).forEach(function(element){
                            element.insertAdjacentHTML('beforeend', disclaimerCGAText)
                        })
                        if (document.querySelector('#DCGAnextpage[value*="interactive.legacybrochure.com"]') !== null) {
                            document.querySelector('#DCGAbrochureform').insertAdjacentHTML('beforeend', disclaimerCGAText)
                        }
                    }
                    else {
                        return false;
                    }
                } else {
                    console.error(rawFile.statusText);
                }
            }
        };
        rawFile.onerror = () => console.error(rawFile.statusText);
        rawFile.open('GET', url, true);
        rawFile.send(null);
    }
    
    Stelter.interactiveBrochuresUpdate = () => {
        if ((document.querySelector('body.charitable-gift-annuities') !== null || document.querySelector('body#charitable-gift-annuities-page') !== null) && window.location.host.indexOf('ingeniuxondemand.com') == -1 && document.querySelector('#nextpage[value*="interactive.legacybrochure.com"]') !== null) {
            Stelter.uberLoadDomains('/documents/stelter/interactive-brochures-updated.txt');
        }
    }
    
    Stelter.addCGAClass = () => {
        if(document.querySelector(`.cga-article`) !== null){
            document.getElementsByTagName(`body`)[0].classList.add(`cga-page`)
        }
    }

    Stelter.replaceAllInstancesText = (oldText, newText, selector) => {
        selector = typeof selector !== 'undefined' ? selector : '*';
        [].slice
            .call(document.querySelectorAll(selector))
            .filter(function (ele) { return ['META', 'BASE', 'LINK', 'SCRIPT', 'IMG', 'STYLE', 'PATH', 'path', 'HTML', 'BODY'].includes(ele.nodeName) == false })
            .filter(function (ele) { return ele.innerHTML.includes(oldText) })
            .forEach(function (ele) {
                [].slice.call(ele.childNodes).filter(function(node){return node.nodeName == '#text'}).forEach(function(node){
                    node.textContent = node.textContent.replace(new RegExp(oldText,'gi'), newText)
                })
            })
    }

    Stelter.journeyPageLinks = () => Array.from(document.querySelectorAll('ul.journey li > a'))

    Stelter.sanitize = string => string.toLowerCase().replace(/\s/g, '')

    Stelter.noWhitespace = string => string.replace(/\s/g, '')

    Stelter.sentenceCase = (string,orgname,short,clientExceptions) => {
        let change = string
            .toLowerCase()
            // eslint-disable-next-line no-useless-escape
            .split(/([\?\.\!])+/g)
            .map(section =>{
                let precedingWhiteSpace = section.length - section.replace(/^\s+/, '').length
                return ' '.repeat(precedingWhiteSpace) + section.charAt(precedingWhiteSpace).toUpperCase() + section.slice(precedingWhiteSpace + 1)
            })
            .join(``)

        // This must go first of all the special cases because it deals with an edge case of the regex splitting on periods PS 05/17/2018
        change.indexOf('vs.') != -1 ? change = change.split('vs.').map((x,index) => index == 1 ? x.toLowerCase() : x ).join('vs.') : null

        // capitalize orgname
        try{
            change.indexOf(orgname.toLowerCase()) != -1 ? change = change.replace(orgname.toLowerCase(),orgname) : null
        } catch(err){
            Stelter.log.push('Did you forget to include @[orgname]?')
        }
        try{
            change.indexOf(short.toLowerCase()) != -1 ? change = change.replace(short.toLowerCase(),short) : null
        } catch(err){
            Stelter.log.push('Did you forget to include @[short]?')
        }
        change.indexOf(` i `) != -1 ? change = change.replace(` i `,` I `) : null
        change.indexOf(`i’m`) != -1 ? change = change.replace(`i’m`,`I’m`) : null
        change.indexOf(`i'm`) != -1 ? change = change.replace(`i'm`,`I’m`) : null
        change.indexOf(` ira `) != -1 ? change = change.replace(` ira `,` IRA `) : null
        change.indexOf(` ira`) != -1 ? change = change.replace(` ira`,` IRA`) : null
        change.indexOf(`Ira `) != -1 ? change = change.replace(`Ira `,`IRA `) : null
        change.indexOf(` diy `) != -1 ? change = change.replace(` diy `,` DIY `) : null
        change.indexOf(` cga `) != -1 ? change = change.replace(` cga `,` CGA `) : null
        change.indexOf(`Cgas`) != -1 ? change = change.replace(`Cgas`,`CGAs`) : null
        change.indexOf(` daf `) != -1 ? change = change.replace(` daf `,` DAF `) : null
        change.indexOf(`Daf `) != -1 ? change = change.replace(`Daf `,`DAF `) : null
        change.indexOf(`(no `) != -1 ? change = change.replace(`(no `, `(No `) : null
        change.indexOf(`warren buffett`) != -1 ? change = change.replace(`warren buffett`,`Warren Buffett`) : null
        change.indexOf(`social security`) != -1 ? change = change.replace(`social security`, `Social Security`) : null
        change.indexOf(`Social security`) != -1 ? change = change.replace(`Social security`, `Social Security`) : null
        change.indexOf(`medicare`) != -1 ? change = change.replace(`medicare`, `Medicare`) : null
        change.indexOf(`cares act`) != -1 ? change = change.replace(`cares act`, `CARES Act`) : null
        Stelter.log.push(typeof clientExceptions)
        if(typeof clientExceptions === 'string'){
            change.indexOf(clientExceptions.toLowerCase()) != -1 ? change = change.replace(clientExceptions.toLowerCase(),clientExceptions) : null
        }
        else if (Array.isArray(clientExceptions)){
            clientExceptions.forEach(item => change.indexOf(item.toLowerCase()) != -1 ? change = change.replace(item.toLowerCase(),item) : null )
        }
        return change
    }

    Stelter.addCaptcha = element => {
        //Not sure where this function is being called from so not updating to altcha in case it's hard coded somewhere?
        jQuery(window).on("load", () => {
            let stringVariableHolder = () => {
                window.grecaptcha.render(element, {
                    sitekey: window.recaptchaKey
                })
            }
            stringVariableHolder()
        })
    }

    // check for valid email address
    Stelter.isEmail = email => /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(email)

    Stelter.isTouchDevice = () => (`ontouchstart` in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)

    Stelter.isiOS = () => navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad)/)

    /* querystring functions for PEPC */
    Stelter.paramExists = parameter => {
        //Get Query String from url
        let fullQString = window.location.search.substring(1)

        if (fullQString.length > 0) {
            //Split Query String into separate parameters
            let paramArray = fullQString.split('&')

            //Loop through params, check if parameter exists.
            for (let i = 0; i < paramArray.length; i++) {
                let currentParameter = paramArray[i].split('=')
                if (currentParameter[0] == parameter) { //Parameter already exists in current url
                    return true
                }
            }
        }
        return false
    }

    Stelter.gup = param => {
        let url = new URL(window.location.href)
        let params = new URLSearchParams(url.search)
        return params.get(param) || ''
    }

    Stelter.validateForm = form => {
        const empty = value => Stelter.isNullOrWhiteSpace(value)
        let fName = form[`first`].value
        let lName = form[`last`].value
        let email = form[`email`].value

        if(empty(fName) || empty(lName) || empty(email)){
            alert('Please Complete Form')
        }
        else{
            return Stelter.isEmail(email) ? true : alert('Enter a valid email')
        }
    }

    Stelter.validateBrochureForm = () => {
        let fName = jQuery.trim(document.forms[`brochureform`][`first`].value)
        let lName = jQuery.trim(document.forms[`brochureform`][`last`].value)
        let email = jQuery.trim(document.forms[`brochureform`][`email`].value)
        let checkpoint = () => {
            if (document.forms[`brochureform`][`honeypot`]) return jQuery.trim(document.forms[`brochureform`][`honeypot`].value)
            if (document.forms[`brochureform`][`ebroCheckpoint`]) return jQuery.trim(document.forms[`brochureform`][`ebroCheckpoint`].value)
        }

        if (`` != checkpoint()) {
            //spam bot filled in hidden field, bypass form submission
            jQuery.magnificPopup.close()
            return false
        } else if (fName != `` && lName != `` && email != ``) {
            if (!Stelter.isEmail(email)) {
                alert(`Please enter a valid email address`)
                return false
            } else {
                jQuery.magnificPopup.close()
                return true
            }
        } else {
            alert(`Please fill in your first name, last name and email address`)
            return false
        }
    }

    Stelter.validatePEPCForm = () => {
        let fName = jQuery.trim(document.forms[`PEPCForm`][`first`].value)
        let lName = jQuery.trim(document.forms[`PEPCForm`][`last`].value)
        let email = jQuery.trim(document.forms[`PEPCForm`][`email`].value)
        let checkpoint = () => {
            if (document.forms[`PEPCForm`][`honeypot`]) return jQuery.trim(document.forms[`PEPCForm`][`honeypot`].value)
            if (document.forms[`PEPCForm`][`pepcCheckpoint`]) return jQuery.trim(document.forms[`PEPCForm`][`pepcCheckpoint`].value)
        }

        if (`` != checkpoint()) {
            //spam bot filled in hidden field, bypass form submission
            jQuery.magnificPopup.close()
            return false

        } else if (fName != `` && lName != `` && email != ``) {
            if (!Stelter.isEmail(email)) {
                alert(`Please enter a valid email address`)
                return false
            } else {
                jQuery.magnificPopup.close()
                return true
            }
        } else {
            alert(`Please fill in your first name, last name and email address`)
            return false
        }
    }

    var dcgaValidated = false;
    Stelter.validateDcgaForm = () => {
        // Adjust DCGA nextpage url if it links to the new digital guide 
        if (jQuery('#DCGAnextpage').length > 0 && !dcgaValidated) {
            try {
                if (jQuery('#DCGAnextpage').val().indexOf('deferred-gift-annuities-guide') > -1) {
                    if (useRewrites == "False") {
                        var DCGAnextpage = jQuery('#DCGAnextpage'); //store for reference
                        var value = DCGAnextpage.val(); //store for reference
                        var host = value.indexOf("ingeniuxondemand.com") == -1 ? "https://" + window.location.hostname : "";
                        var leadingSlash = value.startsWith('/') ? '' : '/';
                        var htmlEbro = value.indexOf("ebr=") > -1;
                        var globalGuide =  value.indexOf("sitecontrol") == -1 && !htmlEbro ? "?sitecontrol=" + pageId : "";

                        dcgaValidated = true;
                        // If we are in preview, need to include "dsspreview" in the href
                        if (serverIs == "preview") {
                            DCGAnextpage.val(host + "/dsspreview" + leadingSlash + value + globalGuide);
                        }
                        else {
                            DCGAnextpage.val(host + leadingSlash + value + globalGuide);                                                                            
                        }
                    }
                }
            }
            catch (err) {
                console.log("Error setting DCGA brochure nextpage | " + err);
            }
        }
        
        let fName = jQuery.trim(document.forms[`DCGAbrochureform`][`first`].value)
        let lName = jQuery.trim(document.forms[`DCGAbrochureform`][`last`].value)
        let email = jQuery.trim(document.forms[`DCGAbrochureform`][`email`].value)
        let checkpoint = () => {
            if (document.forms[`DCGAbrochureform`][`honeypot`]) return jQuery.trim(document.forms[`DCGAbrochureform`][`honeypot`].value)
            if (document.forms[`DCGAbrochureform`][`dcgaCheckpoint`]) return jQuery.trim(document.forms[`DCGAbrochureform`][`dcgaCheckpoint`].value)
        }

        if (`` != checkpoint()) {
            //spam bot filled in hidden field, bypass form submission
            jQuery.magnificPopup.close()
            return false
        } else if (fName != `` && lName != `` && email != ``) {
            if (!Stelter.isEmail(email)) {
                alert(`Please enter a valid email address`)
                return false
            } else {
                jQuery.magnificPopup.close()
                if(!document.forms['DCGAbrochureform'].querySelector("#dcgaReCaptcha")) document.forms['DCGAbrochureform'].action = '../../../action/ebrosendemail.cshtml'
                return true
            }
        } else {
            alert(`Please fill in your first name, last name and email address`)
            return false
        }
    }

    //Avoid using strings that contain html special characters like &nbsp as this will most likely result in no matches
    Stelter.safeSearch = (elementTag,text) => {
        var search = document.evaluate(`//${elementTag}[contains(.,'${text}')]`, document, null, XPathResult.ANY_TYPE,null)
        var searchArray = []
        var tester = ''
        // eslint-disable-next-line no-constant-condition
        while(true){
            tester = search.iterateNext()
            if(tester){
                searchArray.push(tester)
            }
            else{
                break
            }
        }
        return searchArray
    }

    Stelter.accordions = () => {
        const $accordionSection = jQuery(`div.stl-accordion div.stl-section`)
        const $accordionHeader = jQuery(`div.stl-accordion h3.stl-toggle`)

        // Accordions - Hide all, show on section
        $accordionSection.hide()
        $accordionSection.eq(0).slideToggle()
        $accordionHeader.eq(0).addClass(`stl-open`)
        Array.from($accordionHeader).forEach( element => {
            jQuery(element).on('click', () => {
                if (jQuery(element).next().is(`:visible`)) {
                    jQuery(element).next(`div.stl-section`).slideToggle()
                    jQuery(element).toggleClass(`stl-open`)
                } else {
                    $accordionSection.hide()
                    $accordionHeader.removeClass(`stl-open`)
                    jQuery(element).next(`div.stl-section`).slideToggle()
                    jQuery(element).toggleClass(`stl-open`)
                }
            })
        })
    }
    
    Stelter.globalAnnouncement = () => {
        if (jQuery('#stl-announcement').length > 0) {
            // Open announcement if the user has not interacted with it
            if (!localStorage.getItem('stl_global_announcement')) {
                setTimeout(function() {
                    jQuery.magnificPopup.open({
                        items: {
                            src: '#stl-announcement'
                        },
                        mainClass: 'stl-announcement',
                        type:'inline',
                        callbacks: {
                            close: function() {
                                //localStorage.setItem('stl_global_announcement', 'true'); //removed
                            }
                        }
                    });
                },2000);
            }
            // If user goes to announcement nextpage, set local storage so they will not see announcment again (removed this functionality)
//            jQuery('#announcement-nextpage').click(function() {
//                localStorage.setItem('stl_global_announcement', 'true');
//            })
            // If user selects "no thanks/don't show me this again" button, set local storage so they will not see announcement again
            jQuery('#announcement-nextpage').next().click(function() {
                localStorage.setItem('stl_global_announcement', 'true');
                var magnificPopup = jQuery.magnificPopup.instance;
                magnificPopup.close();
            })
        }    
    }
	
	Stelter.digitalGuideLinks = () => {
		// Update digital guide links to ensure they work in staging
		jQuery('.digital-guide-link').each(function () {
			// if we're in staging or preview
			if (useRewrites == "False") {
				var link = jQuery(this).attr('href');
				// if link does not include site control query param already, add it
				if (link.indexOf('sitecontrol') < 0) {
					var siteControlParam = "sitecontrol=" + pageId;
					// if link already has query params, add site control to the end
					if (link.indexOf('?') >= 0) {
						link = link + "&" + siteControlParam;
					}
					// otherwise, add it as the first param
					else {
						link = link + "?" + siteControlParam;
					}
					// set the new href
					jQuery(this).attr('href', link);
				}
			}
		})
	}

    Stelter.digitalGuideLinksGlobal = () => {
		// Update digital guide links on global articles to ensure they work in staging
		jQuery('.digital-guide-link-global').each(function () {
			// if we're in staging or preview
			if (useRewrites == "False") {

                // Pass along the entire query string to the link
				var link = jQuery(this).attr('href');
                link = link + window.location.search;
                jQuery(this).attr('href', link);
			}
		})
	}

    Stelter.linkify = () => {
        let noMailTo = ``
        let at = ``
        let uname = ``
        let domain = ``
        if(typeof linkify !== 'undefined') {
            let options = {
                attributes: (href, type) => {
                    if (type === `email`) {
                        noMailTo = href.substring(7)
                        at = noMailTo.indexOf(`@`)
                        uname = noMailTo.substring(0, at)
                        domain = noMailTo.substring(at + 1, noMailTo.length)
                        return {
                            'data-uname': uname,
                            'data-domain': domain,
                            href: '#'
                        }
                    }
                    return {}
                },
                className: {
                    url: `linkified`,
                    email: `contactEMAddr`
                },
                events: {
                    click: e => {
                        e.preventDefault()
                        window.emailEventListener = true
                        window.location.href = `mailto:` + this.attributes.data - uname.value + `@` + this.attributes.data - domain.value
                    }
                },
                ignoreTags: [
                    `script`,
                    `style`,
                    `noscript`
                ]
            }
            jQuery(`body`).linkify(options)
            if (!window.emailEventListener) {
                Array.from(jQuery(`.contactEMAddr`)).forEach( element => {
                    jQuery(element).on(`click`, e => {
                        e.preventDefault()
                        let uname = jQuery(element).data(`uname`).trim()
                        let domain = jQuery(element).data(`domain`).trim()
                        let email = `mailto:${uname}@${domain}`
                        window.location.href = email
                    })
                })
            }
        }
    }

    /*
        Get the scrollTop of the page, even if the scroll is on a child element.
        This is useful for pages that have a scrollable div instead of the body being scrollable.
        standardFormsSubmit uses this to check if the page has been scrolled before allowing a form to be submitted, 
        unless the form's submit button is visible on load. 
        This is to prevent spam bots from submitting forms without scrolling the page.
        This function can be added to other forms that need to check for scrolling before allowing submission.
        Because this function can potentially check the positioning of every element on the page, 
        we only run it when a form is submitted, and not on every scroll event.
    */
    Stelter.getPageScrollTop = () => {
        const documentScroll =
            window.scrollY ||
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0;
    
        if (documentScroll > 0) {
            return documentScroll;
        }
    
        let bestElement = null;
    
        for (const el of document.querySelectorAll('body *')) {
            // If we find an element that has been scrolled more than 25px, 
            // that would be a good indicator that the user has scrolled the page, and we can stop checking other elements.
            if (el.scrollTop > 0 && el.scrollHeight > el.clientHeight) {
                if (!bestElement || el.clientHeight > bestElement.clientHeight) {
                    bestElement = el;
                }
                if (bestElement.scrollTop > 25) {
                    break;
                }
            }
        }
    
        return bestElement ? bestElement.scrollTop : 0;
    }

    Stelter.contactUsPageFormValidation = () => {
        jQuery(`#stl-contact-form`).submit(e => {
            let fName = jQuery.trim(document.forms[`contactform`][`fname`].value)
            let lName = jQuery.trim(document.forms[`contactform`][`lname`].value)
            let email = jQuery.trim(document.forms[`contactform`][`email`].value)

            let checkpoint = () => {
                if (document.forms[`contactform`][`honeypot`]) return jQuery.trim(document.forms[`contactform`][`honeypot`].value)
                if (document.forms[`contactform`][`contactCheckpoint`]) return jQuery.trim(document.forms[`contactform`][`contactCheckpoint`].value)
            }

            if (`` != checkpoint()) {
                //spam bot filled in hidden field, bypass form submission
                e.stopImmediatePropagation()
                return false
            } else if (fName != `` && lName != `` && email != ``) {
                if (!Stelter.isEmail(email)) {
                    alert(`Please enter a valid email address`)
                    e.stopImmediatePropagation()
                    return false
                } else {
                    return true
                }
            } else {
                alert(`Please fill in your first name, last name and email address`)
                e.stopImmediatePropagation()
                return false
            }
        })
    }
    
    Stelter.standardFormsValidation = () => {
        // Remove disabled attribute from form submit buttons (retroactive fix for SDS sites built 02/19-12/19)
        jQuery('.stl-custom-form button[type=submit]').removeAttr('disabled');
		
        jQuery('.stl-input-field input[required="required"]').blur(function() {
            //var isFormValid = true;

            // Store the parent input group wrapper
            var parent = jQuery(this).parent();
            //var parentForm = jQuery(this).closest(jQuery('form'));

            if (!jQuery(this).val()) {
                //input is empty
                parent.removeClass('active');
                parent.removeClass('valid').addClass('invalid');
            }
            else if (jQuery(this).attr('type') == "email" && (jQuery(this).val().indexOf("@") == -1)) {
                // invalid email address
                parent.removeClass('active');
                parent.removeClass('valid').addClass('invalid');
                return false;
            }
            else {
                // input is valid
                parent.removeClass('invalid').addClass('valid');
            }
        })
    }
    
    Stelter.standardFormsSubmit = () => {
        var tierArray = siteControlTier.split(",").map(tier => tier.trim());
        var sdsArray = ["Standard","Plus","SDS Guides"];
        var sdsSite = sdsArray.some(tier => tierArray.includes(tier));
        // Link PEPC Lesson and Record book pdf downloads to one visible checkbox element
        if (document.getElementById('planning-toolkit-page') !== null) {
            // if planning toolkit visit is from triggered email, hide the form
            if(document.getElementById('planning-toolkit-form') !== null && window.location.search.includes("_content=auto_")) {
                document.getElementById('planning-toolkit-form').classList.add('after-submit')
                if(document.querySelectorAll('.global-option').length) {
                    document.querySelectorAll('.global-option').forEach(el => {
                        if(el.href.includes('guide')) {
                            el.href = el.href.includes('?') ? el.href + '&stl_content=auto_email' : el.href + '?stl_content=auto_email'
                        }
                    })
                }
            }

            var visibleCheckbox = jQuery("#pepc");
            var hiddenCheckbox = jQuery("#recordbook");

            visibleCheckbox.on('change', function(){
                hiddenCheckbox.prop('checked',this.checked);
            });
        }
        
        let scrolled = false;
        let mvmt = 0;
        let keyed = 0;
            
        let checkScroll = () => {
            let documentScroll =
                window.scrollY ||
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop ||
                0;

            /* 
                If page has been scrolled more than 25px, set scrolled to true and remove event listeners.
                At time of submission, we have a secondary check with Stelter.getPageScrollTop() to check if the page has been scrolled, 
                in case the user scrolled a child element instead of the body.
            */  
            if (documentScroll > 25) {
                scrolled = true;
                window.removeEventListener('load', checkScroll, true)
                window.removeEventListener('scroll', checkScroll, true)
            }
        }
            
        let checkMvmt = (event) => { 
            mvmt++;
            if (mvmt > 2) {
                document.removeEventListener('mousemove', checkMvmt, true)
                document.removeEventListener('touchmove', checkMvmt, true)
                document.removeEventListener('touchend', checkMvmt, true)
            }
        }
            
        let checkKeys = (event) => {
                if (event.code === 'Space' || event.code === 'Tab' || event.code.includes('Arrow')) {
                keyed++;
                if (keyed > 2) document.removeEventListener('keydown', checkKeys, true)
            }
        };

        window.addEventListener('load', checkScroll, true)
        window.addEventListener('scroll', checkScroll, true)
        document.addEventListener('mousemove', checkMvmt, true)
        document.addEventListener('touchmove', checkMvmt, true)
        document.addEventListener('touchend', checkMvmt, true)
        document.addEventListener('keydown', checkKeys, true)

        Array.from(document.forms).forEach(form => {
            // check if each form's submit button was visible on page load
            let submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
            let buttonVisible = false;
            if (submitButton) {
                let buttonRect = submitButton.getBoundingClientRect();
                if (
                    buttonRect.top >= 0 &&
                    buttonRect.left >= 0 &&
                    buttonRect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    buttonRect.right <= (window.innerWidth || document.documentElement.clientWidth)
                ) {
                    buttonVisible = true;
                }
            }
            // if submit button was visible, add class to form to indicate this
            if (buttonVisible) {
                form.classList.add('visible-on-load');
            }
        });

        // Global variable to indicate whether reCaptcha is included on the form (false by default)
        var captchaIncluded = false;

        // Generate recaptcha given an id of an empty div
        function generateCaptcha(formcaptcha) {
            if (typeof captchaKey === "undefined" || captchaKey == "" || typeof isIE11 !== "undefined") {
                return false;
            } else {
                const altchaScriptLoaded = !!document.querySelector('#altcha-script') || window.$altcha;
                if (altchaScriptLoaded) {
                    const widget = document.createElement('altcha-widget')
                    const el = document.getElementById(formcaptcha)
                    el.appendChild(widget)
                }
                else {
                    window.addEventListener("load", function () {
                        grecaptcha.render(formcaptcha, {
                            'sitekey': captchaKey
                        });
                    });
                }
                // set captchaincluded to true
                captchaIncluded = true;
            }
        }

        // Render recaptcha if there are any standard forms and this site has recaptcha enabled
        if(document.getElementById('standard-form-captcha')) {
            generateCaptcha("standard-form-captcha");
        }
        if(document.querySelector('.standard-form-captcha')) {
            document.querySelectorAll('.standard-form-captcha').forEach(function(el) {
                generateCaptcha(el.id);
            })
        }
        
        // Save timestamp
        var loadTime = jQuery.now();
        
        // If any options are global and we are not in "true live" (which utilizes url rewrites), add the site control parameter to the global option's href
        try {
            if (useRewrites == "False") {
                jQuery('.global-option').each(function() {
                    var globalOption = jQuery(this); //store for reference
                    var href = globalOption.attr('href'); //store for reference

                    // If we are in preview, need to include "dsspreview" in the href
                    if (serverIs == "preview") {
                        globalOption.attr('href', "//" + window.location.hostname + "/dsspreview" + href + "?sitecontrol=" + pageId);
                    }
                    else {
                        globalOption.attr('href', "//" + window.location.hostname + href + "?sitecontrol=" + pageId);
                    }
                })
            }
        }
        catch (err) {
            console.log("useRewrites is not passed as a global variable in this environment | " + err);
        }

        function resetAltchaSubmit(altcha, standardForm) {
            if (altcha && typeof altcha.reset === 'function') {
                altcha.reset();
            }

            delete standardForm.dataset.submitHandled;
        }

        // Submit standard form
        jQuery('form.stl-custom-form').submit(function(e) {
            e.preventDefault();

            //cache this form
            var form = jQuery(this);
            var standardForm = form[0];

            //reset altcha with each form submission
            const altcha = standardForm.querySelector("altcha-widget");

            if (standardForm.dataset.submitHandled === "true") return;
            standardForm.dataset.submitHandled = "true";

            // Check checkpoint
            if (form.find(jQuery('.checkpoint')).length > 0 && typeof form.find(jQuery('.checkpoint')).attr('value') !== "undefined" && form.find(jQuery('.checkpoint')).attr('value') !== "") {
                return false;
            }
            
            // Check timestamp
            var submitTime = jQuery.now();
            var timeToSubmit = submitTime - loadTime;
            if (timeToSubmit < 5000) {
                return false;
            }

            let scrollRequired = standardForm.classList.contains('visible-on-load') ? false : true;
            // check if a scroll, movement, or key presses have happened
            if (((!scrolled && scrollRequired) && Stelter.getPageScrollTop() < 25) || (mvmt < 2 && keyed < 2)) {
                return false;
            }

            // check HTML validation
            if (!standardForm.checkValidity()) {
                return false;
            }

            // if there is a captcha key value and captcha container exists on the form, set reCaptchaIncluded to true
            if (typeof captchaKey !== "undefined" && captchaKey !== "" && (form.find(jQuery('[id*="captcha"]')).length > 0 || form.find(jQuery('[class*="altcha"]')).length > 0 || form.find(jQuery('[class*="captcha"]')).length > 0)) {
                captchaIncluded = true;
            }

            // If captcha is included, it must be filled out
            if (captchaIncluded && !form.hasClass('recaptcha-disabled')) {
                var isCaptchaFilledOut = form.find(jQuery('.g-recaptcha-response, input[name="altcha"]'));
                if (isCaptchaFilledOut.length === 0 || !isCaptchaFilledOut.val()) {
                    return false;
                }
            }
            
            // Show submitted confirmation
            form.find('.submit-text').addClass('visible');
            form.find('button').attr('disabled','disabled');

            var nextpage = form.find(jQuery("input[name='nextpage']"));
            var nextpageVal = nextpage.attr('value');
            var blankTarget = form.attr('target') === '_blank' && nextpage.attr('data-samepage') !== 'true';
            if (blankTarget) {
                loading('customFormWindow');
            }

            // Check for download options 
            if (form.find(jQuery('.download-option')).length > 0) {
                var files = form.find(jQuery('.download-option:checked')).map(function() {
                    //return this.value; //create array of filenames
                    return jQuery(this).attr('data-value');
                }).get();
                
                var tabs = form.find(jQuery('.tab-option:checked')).map(function() {
                    //return this.value; //create array of filenames
                    return jQuery(this).attr('data-value');
                }).get();

                // Create link to download files
                let dlink = document.createElement('a');
                dlink.style.display = 'none';
                document.body.appendChild(dlink);

                // If more than one download option selected, create a link and set the download attribute
                if (files.length > 1) {
                    // Download each file in the files array
                    for (let i=0, num=files.length; i < num; i++){
                        dlink.setAttribute('download', '');
                        dlink.setAttribute('href', files[i]);
                        dlink.click();
                    }
                }

                // If only one download selected, open in a new tab
                else if (files.length == 1) {
                    dlink.setAttribute('href', files[0]);
                    dlink.setAttribute('target', '_blank');
                    dlink.click();
                }
                
                // If any tab options are selected, open them in new tabs
                if (tabs.length > 0) {
                    // Open each tab in the tabs array
                    for (let i=0, num=tabs.length; i < num; i++){
                        dlink.setAttribute('href', tabs[i]);
                        dlink.setAttribute('target', '_blank');
                        dlink.click();
                    }
                }

                document.body.removeChild(dlink);
                
                // If none of the available options selected, prompt the user to select
                if (files.length <= 0 && tabs.length <= 0) {
                    alert("Please select a resource to download by checking one or more boxes");
                    form.find('.submit-text').removeClass('visible');
                    return false;
                }
            }
            
            // Check if this form contains items to unlock
            if (form.find(jQuery('.unlock-option')).length > 0) {
                
                var unlockOptions = form.find(jQuery('.unlock-option:checked')).map(function() {    
                    //return the class name of items to unlock
                    return jQuery(this).attr('data-unlock');
                }).get();
                
                // If any "unlock" options are selected, mark their corresponding download item as visible 
                if (unlockOptions.length > 0) {
                    // mark as visible the options that are selected 
                    for (let i=0, num=unlockOptions.length; i < num; i++) {
                        form.find(jQuery('.view-options .' + unlockOptions[i] + '')).removeClass('hide');
                        form.find(jQuery('.related-options .' + unlockOptions[i] + '')).addClass('hide');
                    }
                    
                    // if all of the options are selected to view, hide the related options section
                    if (unlockOptions.length == jQuery('.unlock-option').length) {
                        form.find('.related-options').addClass('hide');
                    }
                }
            }
            
            // If we are on the planning toolkit form, replace the page title
            if (form.attr('id') == "planning-toolkit-form") {
                //
            }

            // Send Form to IGX and route to nextpage input
            var data = jQuery(this).serialize();
            //console.log("captchaIncluded: " + captchaIncluded);
            var url = "";

            if (captchaIncluded) {
                if (typeof captchaKey === "undefined" || captchaKey === "" || form.hasClass('recaptcha-disabled')) {
                    url = "../../../action/processform.cshtml";
                } else if (form.hasClass('ebro-process')) {
                    url = "../../../action/ebrosendemailwithcaptcha.cshtml";
                } else if (form.find('altcha-widget').length > 0){
                    url = "../../../action/processformwithaltcha.cshtml";
                }else {
                    url = "../../../action/processformwithcaptcha.cshtml";
                }
            } else {
                url = "../../../action/processform.cshtml";
            }

            jQuery.ajax({
                url: url,
                data: data,
                //dataType: 'json',
                type: 'POST',
                success: function (response) {
                    if (typeof response === "string") {
                        if (response.trim().indexOf("<script>") > -1){
                            var respString = response.replace(/\r?\n|\r\s+/g, '');
                            var respScriptNextPage = respString.split('"')[1];
                            response = {"result":"script","content":respScriptNextPage};
                            nextpageVal = response.content;
                        } else {
                            response = JSON.stringify(response)
                            response = JSON.parse(response)
                        }
                    }

                    console.log("response: " + JSON.stringify(response));

                    if (response.result === "failed") {
                        alert(response.content);
                        e.preventDefault();
                        // Remove submitted confirmation
                        form.find('.submit-text').removeClass('visible');
                        form.find('button').removeAttr('disabled');
                        resetAltchaSubmit(altcha, standardForm);
                        return false;
                    }
                    else {

                        // custom client conversion tracking
                        if (typeof window.clientConversion === "function" && 
                            (typeof stlDigitalData === 'undefined' || !stlDigitalData.internalExternal.includes('internal') || window.location.search.includes('debug=true'))
                        ) {
                            window.clientConversion(form.id);
                        }

                        // Nextpage
                        // If attribute data-samepage="true" is set on the nextpage input, then we should not route to the value of nextpage; instead, activate the form submission text on the current page
                        if (nextpage.attr('data-samepage') === "true") {
                            if (jQuery(window).width() >= 768) {
                                //set the height of the form to not collapse
                                if (form.css('height') < (form.find(jQuery('.visible-after-submit')).length)) {
                                    form.css('height',form.css('height'));
                                }
                            }
                            form.addClass('loading');
                            if (jQuery(window).width() < 768) {
                                //scroll to top of form on mobile
                                jQuery('html, body').animate({
                                    scrollTop: (form.offset().top - 50)
                                }, 100);
                            }
                            setTimeout(function() {
                                form.removeClass('loading');
                                form.addClass('after-submit');
                            }, 800);
                            resetAltchaSubmit(altcha, standardForm);
                            return true;
                        }
                        else {
                            if (useRewrites == "False" && sdsSite && nextpageVal.indexOf('guide') > -1 && nextpageVal.indexOf('//') == -1) {
                                nextpageVal = nextpageVal + "?sitecontrol=" + pageId; 
                            }
                            if (useRewrites == "True" && nextpageVal.indexOf(".xml?ebr=x69") > -1){
                                nextpageVal = "/ebrochure-page?ebr=x69";
                                //console.log('nextpage path rendered')
                            }
                            if (blankTarget) {
                                customFormWindow.location = nextpageVal;
                                if (jQuery.magnificPopup.instance.isOpen) {
                                    jQuery.magnificPopup.close()
                                }
                                resetAltchaSubmit(altcha, standardForm);
                            } else {
                                window.open(nextpageVal, '_self'); //go to the next page after submit
                            }
                        }
                    }

                },
                error: function (response) {
                    //failed to send email 
                    console.log(response);
                    resetAltchaSubmit(altcha, standardForm);
                }
            });
        })
    }
    // check for form sessionStorage values, set them on submit if they don't exist
    Stelter.StandardFormsSetSession = () => {
        var tierArray = siteControlTier.split(",").map(tier => tier.trim());
        var sdsArray = ["Standard","Plus","SDS Guides"];
        if(sdsArray.some(tier => tierArray.includes(tier))) {
            // set current time that js loaded for difference check
            var jsLoad = Date.now();
            // get all gate forms
            var gateForms = document.querySelectorAll('form[name=brochureform],form[name=PEPCForm],form[name=DCGAbrochureform],form[name=PlanningToolkitForm],form.sds-gate-form,form.stl-platform-form');
            Array.from(gateForms).forEach(function(gateForm){
                // remove auto response if recently sent
                if(document.cookie.indexOf('Stl_AutoResponse') > -1 && gateForm.querySelector('input[name="auto_eid"]') !== null){
                    gateForm.querySelectorAll('input[name*="auto_"]').forEach(el => {
                        el.remove()
                    })
                }
                gateForm.addEventListener("submit", function(){
                    var formName = gateForm.getAttribute('name');
                    var subTime = Date.now();
                    var subDiff = subTime - jsLoad;
                    if(subDiff < 5000) {
                        return false;
                    }
                    else {
                        var fName = gateForm.elements.namedItem('first') !== null ? gateForm.elements.namedItem('first').value : gateForm.elements.namedItem('fname') !== null ? gateForm.elements.namedItem('fname').value : "";
                        var lName = gateForm.elements.namedItem('last') !== null ? gateForm.elements.namedItem('last').value : gateForm.elements.namedItem('lname') !== null ? gateForm.elements.namedItem('lname').value : "";
                        var email = gateForm.elements.namedItem('email') !== null ? gateForm.elements.namedItem('email').value : gateForm.elements.namedItem('Email Address') !== null ? gateForm.elements.namedItem('Email Address').value : "";
                        
                        // set the guide id based on the specific form
                        var guideId;
                        if(gateForm.elements.namedItem('eBrochureId') !== null) {
                            guideId = gateForm.elements.namedItem('eBrochureId').value;
                        }
                        else if (formName == 'PEPCForm'){
                            guideId = 'Personal Estate Planning Kit';
                        }
                        else if (formName == 'PlanningToolkitForm') {
                            var checkedOptions = document.querySelectorAll('form[name=PlanningToolkitForm] .resources input[type=checkbox]:checked');
                            var checkedValues = "";
                            Array.from(checkedOptions).forEach(function(option, index){
                                if (index == 0 && sGuides && sGuides !== "") {
                                    checkedValues += option.value;
                                }
                                else {
                                    checkedValues += ", " + option.value;
                                }
                            });
                            guideId = checkedValues;
                        }
                        else {
                            guideId = "";
                        }

                        if(!sFirst || !sLast || !sEmail){
                            sessionStorage.setItem('stlFirst',fName);
                            sessionStorage.setItem('stlLast',lName);
                            sessionStorage.setItem('stlEmail',email);
                        }
                        if(!sGuides){
                            sessionStorage.setItem('stlGuides',guideId);
                        }
                        else {
                            if(sGuides.indexOf(guideId) == -1) {
                                sessionStorage.setItem('stlGuides',sGuides + ", " + guideId);
                            }
                        }
                        sessionStorage.setItem('stlDiff', subDiff);
                        sessionStorage.setItem('stlFormSubmit',subTime);
                        localStorage.setItem('stlLocalStorageTime',Date.now());

                        if(gateForm.querySelector('input[name="auto_eid"]') !== null){
                            var eid = gateForm.querySelector('input[name="auto_eid"]').value;
                            // auto response was sent, set cookie to prevent future sends
                            if(document.cookie.indexOf('Stl_AutoResponse') === -1) {
                                var hours = 120 - (new Date().getHours() - 1);
                                document.cookie = `Stl_AutoResponse=${eid};secure;samesite=strict;max-age=${60*60*hours}`
                            }
                        }
                    }
                })
            })
        }
    }
    // check if visitor has filled out form previously, if yes  
    // remove gate and only send notification if it's a new guide for the visitor
    Stelter.removeGate = (gateFormName) => {
        var tierArray = siteControlTier.split(",").map(tier => tier.trim());
        var sdsArray = ["Standard","Plus","SDS Guides"];
        if(sdsArray.some(tier => tierArray.includes(tier))) {
            if(sFirst && sLast && sEmail && sDiff >= 5000){
                // get all gate forms
                var gateNames = [gateFormName,'brochureform','PEPCForm','DCGAbrochureform','PlanningToolkitForm'];
                var sdsForms = document.querySelectorAll('form[name='+gateFormName+'],form[name=brochureform],form[name=PEPCForm],form[name=DCGAbrochureform],form[name=PlanningToolkitForm],form[name=gift-intention-form],form[name=contactform],form[name=questionform],form.sds-gate-form');
                Array.from(sdsForms).forEach(function(sdsForm){
                    // set each of the input values from the session values
                    if(sdsForm.elements.namedItem('first') !== null) sdsForm.elements.namedItem('first').value = sFirst;
                    if(sdsForm.elements.namedItem('fname') !== null) sdsForm.elements.namedItem('fname').value = sFirst;
                    if(sdsForm.elements.namedItem('last') !== null) sdsForm.elements.namedItem('last').value = sLast;
                    if(sdsForm.elements.namedItem('lname') !== null) sdsForm.elements.namedItem('lname').value = sLast;
                    if(sdsForm.elements.namedItem('first') == null && sdsForm.elements.namedItem('fname') == null && sdsForm.elements.namedItem('last') == null && sdsForm.elements.namedItem('lname') == null) {
                        if(sdsForm.elements.namedItem('Name') !== null) sdsForm.elements.namedItem('Name').value = sFirst + " " + sLast;
                        if(sdsForm.elements.namedItem('name') !== null) sdsForm.elements.namedItem('name').value = sFirst + " " + sLast;
                    }
                    if(sdsForm.elements.namedItem('email') !== null) sdsForm.elements.namedItem('email').value = sEmail;
                    if(sdsForm.elements.namedItem('Email') !== null) sdsForm.elements.namedItem('Email').value = sEmail;
                    if(sdsForm.elements.namedItem('Email Address') !== null) sdsForm.elements.namedItem('Email Address').value = sEmail;
                    // if form is valid, add valid class to input parents and enable the submit button
                    if(sdsForm.checkValidity()){
                        var requiredInputs = sdsForm.querySelectorAll('.stl-input-field input[required]');
                        Array.from(requiredInputs).forEach(function(input){
                            var parent = input.parentNode;
                            parent.classList.remove('active','invalid');
                            parent.classList.add('valid');
                        });
                        sdsForm.querySelector('button[type="submit"]').removeAttribute('disabled');

                        // if the form is a gate form, automatically submit the form
                        if(gateNames.indexOf(sdsForm.name) > -1 || sdsForm.classList.contains('sds-gate-form')){
                            // remove event listener, set new submit listener
                            //console.log(sdsForm.name);
                        }
                    }
                })
            }
        }
    }

    // Performance Platform
    Stelter.performancePlatform = () => {

        // Check for subscriber ID
        var subIdValue = typeof stlDigitalData !== 'undefined' && typeof stlDigitalData.user !== 'undefined' ? stlDigitalData.user.profile.subId : Stelter.gup('subid') !== '' ? Stelter.gup('subid') : '';

        // If there is a value for subscriber ID, set token to bypass forms
        var platformCategory = typeof stlDigitalData !== 'undefined' && typeof stlDigitalData.page.section !== 'undefined' && typeof stlDigitalData.page.section.section3 !== 'undefined' && stlDigitalData.page.section.section3.indexOf('Platform') > -1;
        if (platformCategory && subIdValue !== '') {
            sessionStorage.setItem('stlFormSubmit', Date.now());
            localStorage.setItem('stlLocalStorageTime',Date.now());
        }

        // If we are on a page with an estate planning binder promo and there is a subscriber id, bypass the form on the page
        if (jQuery('.estate-planning-binder-promo').length > 0) {

            if (subIdValue != '') {
            
                // For forms that display directly on the page, bypass form submission and show link to the offer
                jQuery('.stl-platform-form').addClass('after-submit');
                jQuery('.platform-form-container').removeClass('stl-platform-hidden');
                
                // For dialog forms, bypass dialog and show link to the offer
                jQuery('#stl-platform-promo button').addClass('hidden');
                jQuery('#stl-platform-promo .subid').removeClass('hidden');
            }
            else {
                // If there is no subscriber ID, show the form, hide the pass through, and show a thank you message after submit
                jQuery('.platform-form-container .visible-after-submit.stl-pass-through').addClass('hidden');
                jQuery('.platform-form-container .visible-after-submit.stl-thank-you').removeClass('hidden');
                jQuery('.platform-form-container').removeClass('stl-platform-hidden');
            }
        }

        // If there is a link to a local page (example: /planning-toolkit), amend the link to work in staging
        if ((jQuery('.stl-local-page').length > 0) && (useRewrites == "False")) {
            var homepagePath = (jQuery('.stlHomelink').length > 0) ? jQuery('.stlHomelink').attr('href') : '';
            var localpagePath = jQuery('.stl-local-page').attr('href');
            var newPath = window.location.origin + '/' + homepagePath + localpagePath;
            jQuery('.stl-local-page').attr('href', newPath);
        }

    }

    // Detect query parameters and add corresponding classes to html 
    Stelter.queryParams = () => {
        var htmlClasses = document.documentElement.classList
        // Based on the offer in the URL parameters, add a class to the page <html>
        
        // Get the value of the 'stl_offer' parameter from the URL
        var stlOfferValue = Stelter.gup('stl_offer');
    
        // If the 'stl_offer' parameter is found, add its value as a class to the <html> element
        if (stlOfferValue !== '') {
            htmlClasses.add('campaign',stlOfferValue)
        }

        // Optional Giving Docs
        var stlGivingDocs = Stelter.gup('stl_givingdocs')

        if (stlGivingDocs == "on") {
            htmlClasses.add('giving-docs')
        }
        
        // Bypass guide forms if subscriber is found (based on html class), currently isolated to MAW page
        if(document.querySelector('#stl-maw-form-container .digital-guide-link') !== null) {
            document.querySelectorAll('#stl-maw-form-container .digital-guide-link').forEach(el => {
                el.addEventListener('click', () => {
                    var formName = el.closest('.offer').querySelector('em') !== null ? el.closest('.offer').querySelector('em').textContent : el.href.replaceAll('-',' ');
                    if(htmlClasses.contains('subscriber')) {
                        sessionStorage.setItem('stlFormSubmit', Date.now())
                        localStorage.setItem('stlLocalStorageTime',Date.now())
                        _satellite.track('site_tool.interaction',{'toolName': `Subscriber Form Bypass:${formName}:Make a Will guide link`})
                    } else {
                        _satellite.track('site_tool.interaction',{'toolName': `Make a Will:${formName} link`})
                    }
                })
            })
        }

        // Estate Planning Awareness week
        // stl_content=pepk will override the Get My Kit link to go to pepk form page
        if (Stelter.gup('stl_campaign') === 'jb-epaw-pepk' &&
            Stelter.gup('stl_content') === 'pepk' &&
            document.querySelector('a[href*="personal-estate-planning-kit-download"]') !== null) 
            {
                document.querySelectorAll('a[href*="personal-estate-planning-kit-download"]').forEach(el => {
                    el.href = el.href.replace('-download','')
                    el.removeAttribute('target')
                    el.removeAttribute('rel')
                })
            }
    }

    Stelter.GIUrlsOrgId = () => {
        //set the orgId to GI URLs without orgId
        [].slice.call(document.querySelectorAll('.lightbox, .home-lightbox, .secondary-lightbox')).forEach(function(el){
            let isGI = el.href.indexOf('giftillustrator.com') > -1
            let calcUrl = el.href
            if (isGI) {
                calcUrl = calcUrl.replace('http:','https:').replace(':8080','')
                if (calcUrl.indexOf('web.') > -1 && calcUrl.indexOf('orgId') === -1 ) {
                    calcUrl = calcUrl + '?orgId=' + orgId
                }
                if (calcUrl.indexOf('calculator.') > -1 && calcUrl.indexOf('@[OrgId') > -1 ) {
                    calcUrl = calcUrl.replace('@[OrgId]',orgId)
                }
                el.href = calcUrl
            }
        })
    }

    Stelter.giftIllustratorSettings = () => {
        /* 
        * https://github.com/stelter/StelterAPI/issues/163
        * 
        * On pages with an embedded gift illustrator, load a specific calculator and any params if present in the URL
        *
        * Test URLs:
        *
        * CGA portion, set payment schedule default to “deferred payments” 
        * https://utopia.planmylegacy.org/gift-illustrator?stl_calc=gift-annuity&deferment=5 
        *
        * CGA portion
        * https://utopia.planmylegacy.org/gift-illustrator?stl_calc=gift-annuity 
        *
        * CGA portion, set gift type default to “IRA assets”
        * https://utopia.planmylegacy.org/gift-illustrator?stl_calc=gift-annuity&giftType=ira
        *
        */

        // Define the elements where we will look for gift illustrator
        const giftIllustratorElements = [
            "#iFrameResizer0", 
            "#stl-gift-illustrator-container .lightbox", 
            "#gift-illustrator-embed"
        ];
        const iframe = giftIllustratorElements
        .map(sel => document.querySelector(sel))
        .find(el => el !== null);

        // If we are on a page with a gift illustrator iframe or link to an iframe
        if (iframe) {

            // Get the current src URL
            const urlString = iframe.getAttribute("src") || iframe.getAttribute("href");

            if (urlString) {
                
                //URL element for the current src or href value
                const iframeURL = new URL(urlString);
            
                // Parse the current URL
                const params = new URLSearchParams(window.location.search);

                // Gift Illustrator path param - sets the specific page of gift calculator (i.e. Charitable Gift Annuity, etc)
                const pathParam = "stl_calc";
                const paths = [
                    "gift-annuity", 
                    "outright-gift", 
                    "charitable-remainder-trust", 
                    "retained-life-estate", 
                    "bargain-sale", 
                    "lead-trust"
                ];
                const hasExistingPath = paths.find(p => iframeURL.pathname.includes("/" + p));

                // Optional parameters to pass into gift illustrator
                const optionalParams = ["deferment", "ageType", "giftType"];

                // If the URL contains the stl_calc parameter
                if (params.has(pathParam)) {
                    const extraPath = params.get(pathParam);

                    // If the value of the stl_calc parameter is not one of the available paths, exit the script
                    if (!paths.includes(extraPath)) {
                        console.warn("Invalid path parameter:", extraPath);
                        return; // stop the script
                    }

                    // Check whether the URL already contains a path to a specific gift calculator
                    if (!hasExistingPath) {

                        // If no current path is set, insert the path to this gift calculator from the parameter
                        iframeURL.pathname = iframeURL.pathname.replace(/\/$/, "") + "/" + extraPath;
                    }

                    // Append optional parameters if they exist
                    optionalParams.forEach(param => {

                        // TODO add validation for safe param values
                        if (params.has(param)) {
                            iframeURL.searchParams.set(param, params.get(param));
                        }
                    });

                    // Update the page's original gift illustrator iframe src or link href with the new value of the iframeURL
                    iframe.setAttribute(iframe.hasAttribute("src") ? "src" : "href", iframeURL.toString());
                }
            }
        }
    }

    // close Gift Illustrator 2.0 popup with escape
    window.addEventListener("message",(event) => {
        if (!event.origin.includes('giftillustrator.com') && !event.origin.includes('api.stelter.com')) return;
        if(event.data === 'Close Gift Illustrator' && document.querySelector('.mfp-close') !== null) {
            document.querySelector('.mfp-close').click()
        }
    }, false);

    Stelter.flyoverSetup = () => {
        // update flyovers to use magnific and use new styling
        jQuery(`.popup-flyover`).removeClass(`popup-flyover`)
        Array.from(jQuery(`.flyover-link`)).forEach(element => {
            let flyoverRel = jQuery(element).attr(`rel`).toLowerCase()
            jQuery(element).attr(`href`,flyoverRel)
        })
        jQuery(`.flyover-link`).magnificPopup({
            mainClass: `mfp-flyover`,
            type: `inline`,
            fixedContentPos: false,
            fixedBgPos: true,
            closeBtnInside: true,
            preloader: false,
            midClick: true,
            removalDelay: 200
        })
    }

    // Add text to empty anchor tags to fix 508 compliance errors
    Stelter.ComplianceErrorsFiveZeroEight = () => {
        setTimeout(() => {
            jQuery(`#fancybox-close`).html(`<span class='offscreen'>Close</span>`)
            jQuery(`#fancybox-left-ico`).html(`<span class='offscreen'>Left</span>`)
            jQuery(`#fancybox-right-ico`).html(`<span class='offscreen'>Right</span>`)
        }, 100)
    }

    Stelter.fancyboxToMagnificListeners = () => {
        jQuery('.fancybox-form').magnificPopup({
            type: 'inline',
            midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
        })
    }
    
    Stelter.magnificLightbox = function() {
        jQuery('.image-popup-vertical-fit').magnificPopup({
            type: 'image',
            closeOnContentClick: true,
            mainClass: 'mfp-img-mobile',
            image: {
                verticalFit: true
            }
        });
    }

    Stelter.questionnaireSetup = () => {
        const $questionnaire = jQuery('.not-sure-where-to-being-questionnaire')
        const $questionnaireInput = jQuery(`.not-sure-where-to-being-questionnaire input`)
        window.getStartedLoaded = false
        //set the getting started page body background none
        $questionnaire.parent().css(`background-image`, `none`)

        jQuery(`.stl-journey-paths a.stl-popup`).attr(`oncontextmenu`, `return false`)

        Stelter.questionnaireSetupQuestions = (questionnaire = $questionnaire, inputs = $questionnaireInput) => {
            let alphabet = (`abcdefghijklmnopqrstuvwxyz`).split(``)
            Array.from(inputs).forEach(element => {
                jQuery(element).on(`click`, () =>{
                    let parent = jQuery(element).parents(`li`)
                    let choice = parent.attr(`id`) + alphabet[jQuery(element).val()]
                    let nextQ = parent.next().attr(`class`)
                    let nextChoice = choice + nextQ
                    jQuery(`.getting-started-suggestion`).hide()
                    parent.nextAll(`li`).find(`input`).removeAttr(`checked`)
                    parent.nextAll(`li`).hide()
                    if (jQuery(`#${nextChoice}`).length > 0) {
                        jQuery(`#${nextChoice}`).show()
                        jQuery(questionnaire).animate({
                            scrollTop: jQuery(`#` + nextChoice).offset().top
                        }, 500)
                    } else {
                        jQuery(`.${choice}`).show()
                        jQuery(questionnaire).animate({
                            scrollTop: jQuery(`.${choice}`).offset().top
                        }, 500)
                    }
                })
            })
        }
        Stelter.questionnaireSetupQuestions()
        if (!Stelter.isTouchDevice() && jQuery().fancybox) {
            jQuery(`a.fancybox-getting-started`).fancybox({
                'margin': 0,
                'padding': 0,
                'speedIn': 500,
                'speedOut': 500,
                'titlePosition': 'over',
                'transitionIn': 'fade',
                'transitionOut': 'fade',
                'type': 'iframe',
                'scrolling': 'auto',
                'height': 400,
                'width': 700,
                'centerOnScroll': true,
                'onStart': () => {
                    jQuery(document).scrollTop('0')
                    jQuery(`body`).css({
                        'overflow': 'hidden'
                    })
                },
                'onClosed': () => {
                    jQuery(`body`).css({
                        'overflow': 'visible'
                    })
                }
            })
        }
        if (!jQuery().fancybox) {
			// Adobe Launch - 11/2019
			if (isAdobeLaunch) {
				// Quiz initiated 
				var gettingStartedDetails = {
					"quizName":"getStarted"
				}
				jQuery('a.fancybox-getting-started').click(function() {
					_satellite.track("quiz.initiated", gettingStartedDetails);
				})
			}
			
            Stelter.gettingStartedCallback = () => {
                jQuery('.getting-started-popup .mfp-close').detach().appendTo('.getting-started-popup .mfp-content');

                // hide options that only suggest gift types that are excluded
                document.querySelectorAll('.getting-started-suggestion').forEach(suggestion => {
                    var notExcluded = 0;
                    //  iterate through the list of suggestions to see what suggestions are hidden/excluded
                    suggestion.querySelectorAll('ul li').forEach(child => {
                        if (window.getComputedStyle(child).getPropertyValue('display') !== 'none') notExcluded++
                    });
                    // if all the suggestions are excluded, let's hide the corresponding radio option
                    if(notExcluded === 0) {
                        var sClass = suggestion.classList[0];
                        var qGroupID = sClass.substring(0, sClass.length - 1);
                        var qID = sClass.substring(sClass.length - 1, sClass.length);
                        var qArr = ['a','b','c','d'];
                        var qIndex = qArr.indexOf(qID);
                        var qParent = document.querySelector('#'+qGroupID+' input[value="'+qIndex+'"]').parentElement;
                        qParent.style.display = 'none';
                    }
                })

                // Adobe Launch - 11/2019
                // Build up object as quiz progresses
                if (isAdobeLaunch) {
                    jQuery('.not-sure-where-to-being-questionnaire input').click(function() {
                        var question = jQuery(this).attr('id');
                        question = question.split('Option')[0];
                        var value = jQuery(this).attr('data-title');
                        gettingStartedDetails[question] = value;
                    })
                    // Quiz complete
                    jQuery('.intLink').click(function() {
                        var interiorLink = jQuery(this).attr('title');
                        gettingStartedDetails["finalLink"] = interiorLink;
                        _satellite.track("quiz.completed", gettingStartedDetails);
                    })
                }
            };

            if (document.querySelector(`.fancybox-getting-started`) !== null) {
                var replaceReqUrl = document.querySelectorAll(`.not-sure-where-to-being-questionnaire input`).length > 0 && document.querySelector('.fancybox-getting-started').href.indexOf('#') > 0;
                if (replaceReqUrl) {
                    document.querySelector('.fancybox-getting-started').href = typeof document.querySelector('.fancybox-getting-started').dataset.mfpReplace  !== 'undefined' ? document.querySelector('.fancybox-getting-started').dataset.mfpReplace : document.querySelector('.fancybox-getting-started').href.indexOf('#') > 0 ? '#' + document.querySelector('.fancybox-getting-started').href.split('#')[1] : document.querySelector('.fancybox-getting-started').href;
                    Stelter.questionnaireSetupQuestions(document.querySelectorAll('.not-sure-where-to-being-questionnaire'),document.querySelectorAll(`.not-sure-where-to-being-questionnaire input`))
                    jQuery('.fancybox-getting-started').magnificPopup({
                        mainClass:'getting-started-popup',
                        midClick: true,
                        type: 'inline',
                        callbacks: {
                            open: () => {
                                Stelter.gettingStartedCallback()
                            }
                        }
                    })
                } else {
                    var reqUrl = document.querySelector('.fancybox-getting-started').href;
                    fetch(reqUrl)
                    .then(response => response.text())
                    .then(html => {
                        // Initialize the DOM parser
                        var parser = new DOMParser();
                        // Parse the text
                        var test = parser.parseFromString(html, "text/html");
                        Stelter.questionnaireSetupQuestions(test.querySelectorAll('.not-sure-where-to-being-questionnaire'),test.querySelectorAll(`.not-sure-where-to-being-questionnaire input`))
                        let question = test.querySelectorAll('.not-sure-where-to-being-questionnaire')
    
                        jQuery('.fancybox-getting-started').magnificPopup({
                            mainClass:'getting-started-popup',
                            midClick: true,
                            items: {
                                src: question,
                                type: 'inline'
                            },
                            callbacks: {
                                open: () => {
                                    Stelter.gettingStartedCallback()
                                }
                            }
                        })
                        getStartedLoaded = true;
                    })
                }
            }
        }

        if (!jQuery().fancybox) {

            if (jQuery(window).width() > 991) {
                jQuery(`.lightbox, .home-lightbox, .secondary-lightbox`).magnificPopup()
                jQuery(`.lightbox[href*='giftillustrator'], .home-lightbox[href*='giftillustrator'], .secondary-lightbox[href*='giftillustrator']`).magnificPopup({
                    type: 'iframe',
                    mainClass: 'gift-illustrator-popup'
                })
            } else {
                jQuery('.lightbox, .home-lightbox, .secondary-lightbox').attr('target', '_blank')
            }
        }

        if (jQuery('.GIfeature').length) {
            jQuery('a:contains(`@[pgc-container]`)').attr('href', '#pgc-container')
        }

        jQuery('.popup-with-zoom-anim').magnificPopup({
            type: 'inline',

            fixedContentPos: false,
            fixedBgPos: true,

            overflowY: 'auto',

            closeBtnInside: true,
            preloader: false,

            midClick: true,
            removalDelay: 300,
            mainClass: 'my-mfp-zoom-in'
        })
    }

    Stelter.gettingStartedSetup = () => {
        let getting_started = ``
        const getDataTitle = element => jQuery(element).data('title')
        Array.from(jQuery(`.q1 input[type='radio']`)).forEach( element => {
            jQuery(element).on('click', () => {
                getting_started = `${getting_started} 1) ${getDataTitle(element)}`
            })
        })
        Array.from(jQuery(`.q2 input[type='radio']`)).forEach( element => {
            jQuery(element).on('click', () => {
                getting_started = `${getting_started} 2) ${getDataTitle(element)}`
            })
        })
        // Array.from(jQuery(`.getting-started-suggestion a`)).forEach( element => {
        //     jQuery(element).on('click', () => {
		// 		if (isAdobeLaunch) {
        //             //
		// 		}
        //     })
        // })
    }

    Stelter.realEstateToggle = () => {
        if (document.querySelector('.reg-toggle-container')) {
            jQuery('.reg-toggle-box').attr('role', 'button').attr('tabindex', '0')
            jQuery('.reg-content').attr('aria-expanded', 'false')

            let toggleCheck = event => {
                if(event instanceof KeyboardEvent && event.code !== 'Enter') return
                
                let element = event.currentTarget
                let $nextSibling = jQuery(element).next('.reg-content')
                let isVisible = $nextSibling.is(':visible')

                jQuery(element).children(`span.toggle-span`).text(isVisible ? '+' : '-')
                jQuery(element).toggleClass('stl-is-active')

                isVisible ?
                    $nextSibling.slideUp().attr('aria-expanded', 'false')
                    :
                    $nextSibling.slideDown().attr('aria-expanded', 'true')
            }

            Array.from(document.querySelectorAll(`.reg-toggle-box`)).forEach( element => {
                element.addEventListener('click', toggleCheck)
                element.addEventListener('keypress', toggleCheck)
            })
        }
    }

    Stelter.unwrapScriptTags = () => {
        // Unwrap script tags from IGX generated <p> tags
        Array.from(jQuery(`script`)).forEach( element => {
            if (jQuery(element).parent().is(`p`) && jQuery(element).parent().children().size() == 1) {
                jQuery(element).unwrap()
            }
        })
    }

    Stelter.toggleCollapsible = () => {
        // Toggle Plus/Minus for collapsible elements
        Array.from(document.querySelectorAll(`a[data-toggle='collapse']`)).forEach(element => {
            jQuery(element).on(`click`, () => {
                let $jElement = jQuery(element)
                let icon = $jElement.children(`span.glyphicon`)
                let plusIcon = $jElement.children(`span.glyphicon-plus-sign`)
                let minusIcon = $jElement.children(`span.glyphicon-minus-sign`)

                if (plusIcon.length) {
                    icon.removeClass(`glyphicon-plus-sign`).addClass(`glyphicon-minus-sign`)
                } else if (minusIcon.length) {
                    icon.addClass(`glyphicon-plus-sign`).removeClass(`glyphicon-minus-sign`)
                }
            })
        })
    }

    Stelter.journeyUniqueClass = () => {
        // Give each journey section a unique class based on the visible button text. For example, the section giving amount would
        // have the class .giving-amount-wrap applied to it.
        Array.from(jQuery(`.journey-main .stl-col.stl-w-04 .stl-button`)).forEach( element => {
            jQuery(element).parents(`div.stl-col.stl-w-04`).addClass(`${jQuery(element).text().toLowerCase().replace(/\s+/, `-`)}-wrap`)
        })
    }

    Stelter.miscJourney = () => {
        // Capitalize the letters IRA in the Journey 70+ popup box
        let $iraLink = jQuery('.stl-white-popup a:contains("IRA")')
        if ($iraLink.length) {
            $iraLink.html($iraLink.html().replace(/ira/i, `<span class='force-upper'>IRA</span>`))
        }

        // ***** custom-global.js merged code
        jQuery('#journey-paths-details .middle-results').wrap(`<div class='hide'></div>`)
        jQuery('#journey-paths-details .middle-results').addClass(`white-popup-block`)
        jQuery('#journey-paths-details .middle-results').removeClass(`middle-results`)
    }

    Stelter.setLocation = () => {
        var locationSelector = document.getElementById('multilocation-select');
        if (locationSelector !== null) {
            locationSelector.addEventListener('change', (event) => {
                var location = event.target.value;
                if(location !== '') {
                    window.location.href = window.location.href.split('?')[0] + '?pgloc=' + location
                }
            })
            
        }
    }

    Stelter.ebrochureCustom = () => {
        // Merged from eBrochure Global
        if (jQuery('body.ebrochure-page').length > 0) {
            let path = 'ebr=x68'
            let path2 = 'ebr=x70'
            if (!(window.location.search.replace('?', '').match(path) ||
                    window.location.search.replace('?', '').match(path2))) {
                jQuery('body.ebrochure-page .cga-copyright').css('display', 'none')
            }
        }
    }

    Stelter.contentReplaceFix = () => {

        // Gift Illustrator variable replacement
        if (jQuery('.GIfeature').length) {
            jQuery(`a:contains('@[pgc-container]')`).attr('href', '#pgc-container')
        }

    }

    Stelter.captchaWindow = () => {
        window.captchaWidgetForPEPC = ''
        window.captchaWidgetForEbro = ''
        window.captchaWidgetForDCGA = ''
        window.captchaWidgetForContact = ''


        const setUpAltcha = () => {
            const loadAltcha = (elementId, widgetVarName) => {
                let el = document.getElementById(elementId);
                if (!el || el.childNodes.length > 0) return;
                let widget = document.createElement('altcha-widget')
                el.appendChild(widget)
                window[widgetVarName] = widget
            }

            const observeDcgaContainer = () => {
                const tryLoadDcga = () => {
                    const el = document.getElementById('dcgaReCaptcha');
                    if (!el) return false;
                    el.innerHTML = '';
                    const widget = document.createElement('altcha-widget');
                    el.appendChild(widget);
                    window.captchaWidgetForDCGA = widget;

                    return true;
                };

                if (tryLoadDcga()) return;

                const observer = new MutationObserver(() => {
                    if (tryLoadDcga()) {
                        observer.disconnect();
                    }
                });

                observer.observe(document.body, {
                    childList: true,
                    subtree: true
                });
            };

            loadAltcha('pepcReCaptcha', 'captchaWidgetForPEPC')
            loadAltcha('ebroReCaptcha', 'captchaWidgetForEbro')
            loadAltcha('dcgaReCaptcha', 'captchaWidgetForDCGA')
            loadAltcha('contactCaptcha', 'captchaWidgetForContact')
            observeDcgaContainer();
        }

        const altchaScriptLoaded = !!document.head.querySelector('script[src*="altcha"]') || !!document.querySelector('#altcha-script') || window.$altcha
        if (altchaScriptLoaded) {
            setUpAltcha()
        }

        window.onloadCallback = () => {
            const isRecaptchaAvailable = typeof window.grecaptcha !== 'undefined';

            const renderCaptcha = (elementId, widgetVarName) => {
                const el = document.getElementById(elementId);
                if (!isRecaptchaAvailable || !el || el.childNodes.length > 0) return;
                
                window[widgetVarName] = window.grecaptcha.render(elementId, {
                    sitekey: window.captchaKey
                });
            };

            renderCaptcha('pepcReCaptcha', 'captchaWidgetForPEPC')
            renderCaptcha('ebroReCaptcha', 'captchaWidgetForEbro')
            renderCaptcha('dcgaReCaptcha', 'captchaWidgetForDCGA')
            renderCaptcha('contactCaptcha', 'captchaWidgetForContact')
        }
    }

    Stelter.dynamicScriptLoad = () => {
        const isRecaptcha = document.querySelector('mycaptcha') != null

        const scriptAlreadyLoaded = 
            document.head.querySelector('script[src*="recaptcha/api.js"]') ||
            document.querySelector('#altcha-script') ||
            window.$altcha

        if(!scriptAlreadyLoaded) {
            var script = document.createElement('script')
            script.async = 'true'
            if (isRecaptcha) {
                script.src = 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit'
                document.head.appendChild(script)
            }
            else {
                script.id = "altcha-script"
                script.type = "module";
                script.textContent = `import * as altcha from '/documents/stelter/js/altcha.esm.min.js'; if (window.$altcha) {window.$altcha.defaults.set({challenge: 'https://altcha.stelter.com/v1/challenge?apiKey=${window.captchaKey}', workers: 4, hideLogo: true, hideFooter: true});}`;
                document.body.appendChild(script)
            }

            
        }
    }

    Stelter.whatsNewCharEncodeFix = () => {
        let element = document.querySelectorAll('#stl-whats-new-listing')[0]
        let holder = element.cloneNode(true)
        /* eslint-disable */
        holder.innerHTML = holder.innerHTML.replace(/\&amp\;rsquo\;/g,'&#8217')
        holder.innerHTML = holder.innerHTML.replace(/\&amp\;lsquo\;/g,'&#8216')
        holder.innerHTML = holder.innerHTML.replace(/\&amp\;ldquo\;/g,'&#8220')
        holder.innerHTML = holder.innerHTML.replace(/\&amp\;rdquo\;/g,'&#8221')
        /* eslint-enable */
        element.innerHTML = holder.innerHTML
    }

    Stelter.setHTMLClassTag()
    Stelter.isiOS()
    Stelter.setBodyId()
    Stelter.dynamicScriptLoad()
    // Binding validation methods to window to keep backwards compatability
    window.validateBrochureForm = Stelter.validateBrochureForm
    window.validatePEPCForm = Stelter.validatePEPCForm
    window.validateDcgaForm = Stelter.validateDcgaForm

    window.serverIs !== 'preview' ? Stelter.captchaWindow() : null
    document.querySelectorAll('#stl-whats-new-listing').length ? Stelter.whatsNewCharEncodeFix() : null

    jQuery(`.journey-paths a[data-toggle='modal']`).magnificPopup({
        type: 'inline',
        midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    })
    Stelter.fancyboxToMagnificListeners()
    Stelter.magnificLightbox()
    Stelter.questionnaireSetup()
    Stelter.linkify()
	Stelter.digitalGuideLinks()
    Stelter.digitalGuideLinksGlobal()

    if(document.querySelectorAll('#stl-whats-new-listing').length > 0){
        Stelter.whatsNewCharEncodeFix()
    }

    if(window.serverIs == 'live' && document.querySelector('a[href*=xml]') !== null){
        var brokenXmlLinks = Array.from(document.querySelectorAll('a[href*=xml]'))
        brokenXmlLinks.forEach(function(link){
            if(link.innerText.includes('IRA')){
                link.href = '/ira-charitable-rollover'
            }
            else {
                // eslint-disable-next-line no-console
                console.log(link)
            }
        })
    }

    Stelter.cgaFundItQCD = () => {
        var navLinks = Array.from(document.querySelectorAll('.stl-nav a'));
        // On CGA page, add IRA Assets link to Fund It section
        if (document.body.id == 'charitable-gift-annuities-page' || 
        document.body.classList.contains('charitable-gift-annuities') || 
        (typeof document.forms.brochureform !== "undefined" && document.forms.brochureform.pageName.value == 'Charitable Gift Annuities')) {
            // On the CGA page
            if (document.querySelector('.learn-how-to-fund') !== null && navLinks.length > 0 && document.querySelector('.learn-how-to-fund a[href*="ira"]') === null && document.querySelector('.learn-how-to-fund a[href*="qcd"]') === null && document.querySelector('.learn-how-to-fund a[href*="qualified-charitable-distribution"]') === null) {
                // No IRA link exists in the Fund It section, check top navigation for IRA URL
                var iraLink = '';
                if (typeof navLinks.find(el => el.textContent.includes('IRA')) !== 'undefined') {
                    iraLink = navLinks.find(el => el.textContent.includes('IRA')).href;
                } else if (typeof navLinks.find(el => el.textContent.includes('QCD')) !== 'undefined') {
                    iraLink = navLinks.find(el => el.textContent.includes('QCD')).href;
                } else if (typeof navLinks.find(el => el.textContent.toLowerCase().includes('qualified charitable distribution')) !== 'undefined') {
                    iraLink = navLinks.find(el => el.textContent.toLowerCase().includes('qualified charitable distribution')).href;
                } else {
                    // No IRA/QCD link in the navigation, so an IRA link cannot be added
                }
                
                if (iraLink !== '') {
                    var assetsCasing = document.documentElement.classList.contains('sentence-case') ? 'assets' : 'Assets'
                    var iraLinkHtml = `<li><a href="${iraLink}"><span class="force-upper">IRA</span>&nbsp;${assetsCasing}</a></li>`
                    document.querySelector('.learn-how-to-fund ul').insertAdjacentHTML('beforeend', iraLinkHtml)
                    if (document.querySelector('#cga-ira-link') !== null && document.querySelector('#cga-ira-link a') === null) {
                        var mainCopyIRALinkContent = document.querySelector('#cga-ira-link').textContent;
                        var mainCopyIRALinkHtml = `<a href="${iraLink}">${mainCopyIRALinkContent}</a>`;
                        document.querySelector('#cga-ira-link').textContent = '';
                        document.querySelector('#cga-ira-link').insertAdjacentHTML('beforeend',mainCopyIRALinkHtml);
                    }
                }
            }
        }
        // Add CGA link on RPA page
        if (document.querySelector('#rpa-cga-link') !== null && document.querySelector('#rpa-cga-link a') === null && navLinks.length > 0) {
            // span does not contain link, check the navigation for the CGA link
            var cgaLink = '';
            if (typeof navLinks.find(el => el.textContent.toLowerCase().includes('gift annuit')) !== 'undefined') {
                cgaLink = navLinks.find(el => el.textContent.toLowerCase().includes('gift annuit')).href;
                var rpaCGALinkContent = document.querySelector('#rpa-cga-link').textContent;
                var rpaCGALinkHtml = `<a href="${cgaLink}">${rpaCGALinkContent}</a>`;
                document.querySelector('#rpa-cga-link').textContent = '';
                document.querySelector('#rpa-cga-link').insertAdjacentHTML('beforeend',rpaCGALinkHtml);
            } else {
                // No CGA link in the navigation, so a CGA link cannot be added
            }
        } 
    }

    Stelter.caseStudyFix = () => {
        if(document.querySelector('.case-study p') !== null) {
            Stelter.replaceAllInstancesText(' percent ','% ','.case-study p')
        }
    }

    //Global CTAs
	Stelter.globalCTALinks = () => {

        if (document.querySelector(".syndicated") && document.querySelector(".stl-globalCTA")){
    
            let isSDS = false, hasGuides = false, tierArray = siteControlTier.split(',').map(function(tier) {
                return tier.trim()
            }), guideTiers = ['Standard', 'Plus', 'SDS Guides'], sdsTiers = ['Standard', 'Plus'];
    
            const containsTier = (array, values) => values.some(value => array.includes(value));
            hasGuides = containsTier(tierArray, guideTiers);
            isSDS = containsTier(tierArray, sdsTiers);
    
            let CTAs = document.querySelectorAll(".stl-globalCTA");
            [].forEach.call(CTAs, function(cta) {
                //Guide CTAs
                let ghref, guideLinks = cta.querySelectorAll(".global-guide a");
                [].forEach.call(guideLinks, function(glink) {
                    if(hasGuides){
                        ghref = glink.dataset.link_sds;
                        // if we're in staging or preview
                        if ('False' == useRewrites) {
                            // if link does not include site control query param already, add it
                            if (ghref.indexOf('sitecontrol') < 0) {
                                let siteControlParam = 'sitecontrol=' + homeId; 
                                ghref = 0 <= ghref.indexOf('?') ? ghref + '&' + siteControlParam : ghref + '?' + siteControlParam;
                            }
                        }
                    }else {
                        // remove cta if no dmp link
                        if(glink.dataset.link_dmp){
                            ghref = glink.dataset.link_dmp;
                        }else {
                            cta.remove();
                        }
                    }
                    glink.href = ghref;
                    glink.target = "_blank";
                });
    
                // Replace // with / in Live links
                let ctahref, ctaLinks = cta.querySelectorAll(".stl-globalCTA a");
                [].forEach.call(ctaLinks, function(ctalink) {
                    ctahref = ctalink.getAttribute('href');
                    if (useRewrites) {
                        ctalink.href = ctahref.replace(/^\/\//, '/');
                    }
                });
                
            });
        }
    }

    Stelter.removeEmpties()
    Stelter.accordions()
    // Contact Us page form validation
    Stelter.contactUsPageFormValidation()
    //set the orgId to GI URLs without orgId
    Stelter.GIUrlsOrgId()
    Stelter.ComplianceErrorsFiveZeroEight()
    Stelter.gettingStartedSetup()
    Stelter.realEstateToggle()
    // Unwrap script tags from IGX generated <p> tags
    Stelter.unwrapScriptTags()
    Stelter.toggleCollapsible()
    Stelter.journeyUniqueClass()
    Stelter.miscJourney()
    Stelter.setLocation()
    Stelter.ebrochureCustom()
    Stelter.contentReplaceFix()
    Stelter.flyoverSetup()
    Stelter.addVideoCaptions()
    Stelter.removeVideoDownloadButton()
    Stelter.interactiveBrochuresUpdate()
    Stelter.addCGAClass()
    Stelter.standardFormsSubmit()
    Stelter.standardFormsValidation()
    Stelter.StandardFormsSetSession()
    Stelter.removeGate()
    Stelter.performancePlatform()
    Stelter.queryParams()
    Stelter.cgaFundItQCD()
    Stelter.caseStudyFix()
    Stelter.globalCTALinks()
    Stelter.giftIllustratorSettings()

    //uncomment globalAnnouncement() when ready to trigger global announcements
    //Stelter.globalAnnouncement() 

    // wait for all elements to be available
    jQuery(window).on("load", function() {
        jQuery('.g-recaptcha-response').attr('aria-hidden', 'true').attr('aria-label', 'recaptcha response')
    })
})